import { Decoration_Type, Node_Type, LATEST_VERSION, TextStyle_TextAlignment, Link_Target, ButtonData, DividerData, FileData, GalleryData, GIFData, HTMLData, ImageData, LinkPreviewData, MapData, AppEmbedData, VideoData, AudioData, PollData, EmbedData, CollapsibleListData, TableData, NullValue, PluginContainerData_Alignment, PluginContainerData_Width_Type, ButtonData_Type, HTMLData_Source, RichContent } from 'ricos-schema';
import { isEmpty as isEmpty$1, negate, sortBy, last, initial, intersection, includes, uniqueId, cloneDeep, isObject, isNumber, has as has$1, pickBy, identity as identity$1, flowRight, merge, isNaN as isNaN$1, omit } from 'lodash';
import { v4 } from 'uuid';

var __defProp$f = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
const convertDocumentStyleDecorationTypes = (decorations) => {
  let draftBlockStyles = {};
  decorations.forEach((decoration) => {
    decoration && (draftBlockStyles = __spreadValues$f(__spreadValues$f({}, draftBlockStyles), ricosDecorationToCss[decoration.type](decoration)));
  });
  return draftBlockStyles;
};
const ricosDecorationToCss = {
  [Decoration_Type.BOLD]: ({ fontWeightValue }) => {
    return fontWeightValue ? { "font-weight": fontWeightValue >= 700 ? "bold" : "normal" } : {};
  },
  [Decoration_Type.ITALIC]: ({ italicData }) => {
    return typeof italicData !== "undefined" ? { "font-style": italicData ? "italic" : "normal" } : {};
  },
  [Decoration_Type.UNDERLINE]: ({ underlineData }) => {
    return typeof underlineData !== "undefined" ? {
      "text-decoration": underlineData ? "underline" : "none"
    } : {};
  },
  [Decoration_Type.FONT_SIZE]: ({ fontSizeData }) => {
    return fontSizeData ? { "font-size": fontSizeData.value + (fontSizeData.unit.toLowerCase() || "px") } : {};
  },
  [Decoration_Type.COLOR]: ({ colorData }) => {
    const { foreground, background } = colorData;
    const colors = {};
    foreground && (colors["color"] = foreground);
    background && (colors["background-color"] = background);
    return colors;
  }
};
const convertNodeStyleToCss = (nodeStyle) => {
  const css = {};
  nodeStyle.paddingTop && (css["padding-top"] = nodeStyle.paddingTop);
  nodeStyle.paddingBottom && (css["padding-bottom"] = nodeStyle.paddingBottom);
  nodeStyle.lineHeight && (css["line-height"] = nodeStyle.lineHeight);
  return css;
};
const parseDocStyle$1 = (documentStyle) => {
  const draftDocStyle = {};
  Object.entries(documentStyle).forEach(([header, values]) => {
    if (values) {
      const { decorations = [], nodeStyle, lineHeight } = values;
      draftDocStyle[header] = __spreadValues$f(__spreadValues$f({}, convertDocumentStyleDecorationTypes(decorations)), convertNodeStyleToCss(__spreadProps$d(__spreadValues$f({}, nodeStyle), { lineHeight })));
    }
  });
  return draftDocStyle;
};

const HEADER_BLOCK = Object.freeze({
  ONE: "header-one",
  TWO: "header-two",
  THREE: "header-three",
  FOUR: "header-four",
  FIVE: "header-five",
  SIX: "header-six",
  PARAGRAPH: "unstyled"
});
const WRAP = "wrap";
const NO_WRAP = "nowrap";
const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";
const DIVIDER_TYPE = "wix-draft-plugin-divider";
const FILE_UPLOAD_TYPE = "wix-draft-plugin-file-upload";
const GALLERY_TYPE = "wix-draft-plugin-gallery";
const GIPHY_TYPE = "wix-draft-plugin-giphy";
const HTML_TYPE = "wix-draft-plugin-html";
const IMAGE_TYPE = "wix-draft-plugin-image";
const IMAGE_TYPE_LEGACY = "IMAGE";
const SPOILER_TYPE = "wix-rich-content-plugin-spoiler";
const COLLAPSIBLE_LIST_TYPE = "wix-rich-content-plugin-collapsible-list";
const LINK_TYPE = "LINK";
const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";
const MAP_TYPE = "wix-draft-plugin-map";
const MENTION_TYPE = "mention";
const APP_EMBED_TYPE = "wix-draft-plugin-vertical-embed";
const VIDEO_TYPE = "wix-draft-plugin-video";
const AUDIO_TYPE = "ricos-audio";
const VIDEO_TYPE_LEGACY = "VIDEO-EMBED";
const POLL_TYPE = "wix-draft-plugin-poll";
const TABLE_TYPE = "wix-rich-content-plugin-table";
const ANCHOR_TYPE = "ANCHOR";
const EMBED_TYPE = "EMBED";
const EXTERNAL = "EXTERNAL";
Node_Type.DIVIDER;
Node_Type.IMAGE;
Node_Type.GALLERY;
Node_Type.FILE;
Node_Type.GIF;
Node_Type.VIDEO;
Node_Type.AUDIO;
Node_Type.LINK_PREVIEW;
Node_Type.EMBED;
Node_Type.POLL;
Node_Type.APP_EMBED;
Node_Type.COLLAPSIBLE_LIST;
Node_Type.COLLAPSIBLE_ITEM;
Node_Type.COLLAPSIBLE_ITEM_TITLE;
Node_Type.COLLAPSIBLE_ITEM_BODY;
Node_Type.HTML;
Node_Type.CODE_BLOCK;
Node_Type.TABLE;
Node_Type.TABLE_ROW;
Node_Type.TABLE_CELL;
const RICOS_NODE_TYPE_TO_DATA_FIELD = {
  [Node_Type.BUTTON]: "buttonData",
  [Node_Type.DIVIDER]: "dividerData",
  [Node_Type.FILE]: "fileData",
  [Node_Type.GALLERY]: "galleryData",
  [Node_Type.GIF]: "gifData",
  [Node_Type.HTML]: "htmlData",
  [Node_Type.IMAGE]: "imageData",
  [Node_Type.COLLAPSIBLE_LIST]: "collapsibleListData",
  [Node_Type.LINK_PREVIEW]: "linkPreviewData",
  [Node_Type.MAP]: "mapData",
  [Node_Type.APP_EMBED]: "appEmbedData",
  [Node_Type.VIDEO]: "videoData",
  [Node_Type.POLL]: "pollData",
  [Node_Type.TABLE]: "tableData",
  [Node_Type.TABLE_CELL]: "tableCellData",
  [Node_Type.PARAGRAPH]: "paragraphData",
  [Node_Type.LIST_ITEM]: "paragraphData",
  [Node_Type.HEADING]: "headingData",
  [Node_Type.CODE_BLOCK]: "codeBlockData",
  [Node_Type.BLOCKQUOTE]: "paragraphData",
  [Node_Type.EMBED]: "embedData",
  [Node_Type.EXTERNAL]: "externalData",
  [Node_Type.AUDIO]: "audioData"
};

var __defProp$e = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
const INLINE_HEADER = {
  ONE: "inline-header-one",
  TWO: "inline-header-two",
  THREE: "inline-header-three",
  FOUR: "inline-header-four",
  FIVE: "inline-header-five",
  SIX: "inline-header-six"
};
const INLINE_HEADERS = [INLINE_HEADER.THREE, INLINE_HEADER.TWO, INLINE_HEADER.ONE];
const INLINE_HEADER_TO_BLOCK = {
  [INLINE_HEADER.ONE]: HEADER_BLOCK.ONE,
  [INLINE_HEADER.TWO]: HEADER_BLOCK.TWO,
  [INLINE_HEADER.THREE]: HEADER_BLOCK.THREE,
  [INLINE_HEADER.FOUR]: HEADER_BLOCK.FOUR,
  [INLINE_HEADER.FIVE]: HEADER_BLOCK.FIVE,
  [INLINE_HEADER.SIX]: HEADER_BLOCK.SIX
};
const removeInlineHeaderRanges = (block) => {
  const inlineHeaderRanges = getInlineHeaderRanges(block.inlineStyleRanges || []);
  if (isEmpty$1(inlineHeaderRanges)) {
    return block;
  }
  return __spreadProps$c(__spreadValues$e({}, block), {
    type: getBlockType(block.type, block.text, inlineHeaderRanges),
    inlineStyleRanges: omitInlineHeaderRanges(block.inlineStyleRanges || [])
  });
};
const isInlineHeaderRange = (range) => includes(INLINE_HEADERS, range.style);
const omitInlineHeaderRanges = (ranges) => ranges.filter(negate(isInlineHeaderRange));
const getInlineHeaderRanges = (ranges) => ranges.filter(isInlineHeaderRange);
const getBlockType = (type, text, inlineHeaderRanges) => type === "unstyled" && shouldConvertToHeaderBlock(text, inlineHeaderRanges) ? getBlockHeaderType(inlineHeaderRanges) : type;
const shouldConvertToHeaderBlock = (text, inlineStyleRanges) => sortBy(inlineStyleRanges, "offset").map((range) => [range.offset, range.offset + range.length]).reduce((ranges, range) => {
  const lastRange = last(ranges);
  return lastRange && isOverlapping(lastRange, range) ? [...initial(ranges), mergeOverlappingRanges(lastRange, range)] : [...ranges, range];
}, []).reverse().reduce((text2, range) => `${text2.slice(0, range[0])}${text2.slice(range[1])}`, text).replace(/\s/g, "").length === 0;
const isInRange = (number, range) => range[0] <= number && number <= range[1];
const isOverlapping = (rangeA, rangeB) => rangeA && rangeB && (isInRange(rangeB[0], rangeA) || isInRange(rangeB[1], rangeA));
const mergeOverlappingRanges = (rangeA, rangeB) => [
  Math.min(rangeA[0], rangeB[0]),
  Math.max(rangeA[1], rangeB[1])
];
const getBlockHeaderType = (inlineHeaderRanges) => {
  const smallestInlineHeader = intersection(
    INLINE_HEADERS,
    inlineHeaderRanges.map((range) => range.style)
  )[0];
  return INLINE_HEADER_TO_BLOCK[smallestInlineHeader];
};

function generateId(prefix = "") {
  const key = Math.random().toString(36).substr(2, 5);
  return `${key}${uniqueId(prefix)}`;
}

// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */
/**
 * @since 2.0.0
 */
function identity(a) {
    return a;
}
function flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch (arguments.length) {
        case 1:
            return ab;
        case 2:
            return function () {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function () {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function () {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function () {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function () {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function () {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function () {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function () {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function pipe$1(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for (var i = 1; i < arguments.length; i++) {
                ret = arguments[i](ret);
            }
            return ret;
    }
}

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------
/** @internal */
var isLeft$1 = function (ma) { return ma._tag === 'Left'; };
/** @internal */
var left$1 = function (e) { return ({ _tag: 'Left', left: e }); };
/** @internal */
var right$1 = function (a) { return ({ _tag: 'Right', right: a }); };
// -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------
/** @internal */
var has = Object.prototype.hasOwnProperty;

/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @category combinators
 * @since 2.11.0
 */
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(N.MagmaSub)(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), -6)
 *
 * @since 2.11.0
 */
var concatAll$2 = function (M) { return function (startWith) { return function (as) {
    return as.reduce(function (a, acc) { return M.concat(a, acc); }, startWith);
}; }; };

/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * Always return the first argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.first<number>().concat(1, 2), 1)
 *
 * @category instances
 * @since 2.10.0
 */
var first = function () { return ({ concat: identity }); };
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * const sum = concatAll(N.SemigroupSum)(0)
 *
 * assert.deepStrictEqual(sum([1, 2, 3]), 6)
 * assert.deepStrictEqual(sum([]), 0)
 *
 * @since 2.10.0
 */
var concatAll$1 = concatAll$2;

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('a', S.toUpperCase), 'A')
 *
 * @category combinators
 * @since 2.11.0
 */
var toUpperCase = function (s) { return s.toUpperCase(); };
/**
 * @example
 * import * as S from 'fp-ts/string'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('abc', S.replace('b', 'd')), 'adc')
 *
 * @category combinators
 * @since 2.11.0
 */
var replace = function (searchValue, replaceValue) { return function (s) {
    return s.replace(searchValue, replaceValue);
}; };

function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}

var __defProp$d = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createNode = (type, {
  nodes,
  data,
  style,
  id
}) => __spreadProps$b(__spreadValues$d({
  type,
  id: id != null ? id : generateId(),
  nodes
}, dataByNodeType(type, data)), {
  style
});
const dataByNodeType = (type, data) => ({
  [Node_Type.CODE_BLOCK]: { codeBlockData: data },
  [Node_Type.DIVIDER]: { dividerData: data },
  [Node_Type.HEADING]: { headingData: data },
  [Node_Type.FILE]: { fileData: data },
  [Node_Type.GALLERY]: { galleryData: data },
  [Node_Type.GIF]: { gifData: data },
  [Node_Type.HTML]: { htmlData: data },
  [Node_Type.IMAGE]: { imageData: data },
  [Node_Type.BUTTON]: { buttonData: data },
  [Node_Type.MAP]: { mapData: data },
  [Node_Type.PARAGRAPH]: { paragraphData: data },
  [Node_Type.POLL]: { pollData: data },
  [Node_Type.TEXT]: { textData: data },
  [Node_Type.VIDEO]: { videoData: data },
  [Node_Type.AUDIO]: { audioData: data },
  [Node_Type.EMBED]: { embedData: data },
  [Node_Type.APP_EMBED]: { appEmbedData: data },
  [Node_Type.LINK_PREVIEW]: { linkPreviewData: data },
  [Node_Type.TABLE]: { tableData: data },
  [Node_Type.TABLE_CELL]: { tableCellData: data },
  [Node_Type.COLLAPSIBLE_LIST]: { collapsibleListData: data },
  [Node_Type.BULLETED_LIST]: {
    bulletedListData: data
  },
  [Node_Type.ORDERED_LIST]: {
    orderedListData: data
  }
})[type];
const createParagraphNode = (nodes = [], data, style) => createNode(Node_Type.PARAGRAPH, {
  nodes,
  data: __spreadValues$d({
    textStyle: { textAlignment: TextStyle_TextAlignment.AUTO }
  }, data),
  style
});
const createTextNode = (text, decorations = []) => createNode(Node_Type.TEXT, { nodes: [], id: "", data: { text, decorations } });
const initializeMetadata = ({
  version,
  id = v4(),
  createdTimestamp,
  updatedTimestamp
} = {}) => ({
  version: version || LATEST_VERSION,
  createdTimestamp: createdTimestamp || /* @__PURE__ */ new Date(),
  updatedTimestamp: updatedTimestamp || /* @__PURE__ */ new Date(),
  id
});
const toLinkTarget = (target = "BLANK") => {
  switch (pipe$1(target, toUpperCase, replace("_", ""))) {
    case "SELF": {
      return Link_Target.SELF;
    }
    case "BLANK": {
      return Link_Target.BLANK;
    }
    case "PARENT": {
      return Link_Target.PARENT;
    }
    case "TOP": {
      return Link_Target.TOP;
    }
    default: {
      return Link_Target.BLANK;
    }
  }
};
const createLink = ({
  url,
  rel,
  target,
  anchor
}) => {
  const relValues = (typeof rel === "string" ? rel : "").split(" ").filter((key) => ["nofollow", "sponsored", "ugc", "noreferrer"].includes(key)).map((key) => [key, true]) || [];
  return {
    anchor,
    url,
    rel: relValues.length > 0 ? fromEntries(relValues) : void 0,
    target: toLinkTarget(typeof target === "string" ? target : void 0)
  };
};
const parseLink$1 = ({
  url,
  rel,
  target,
  anchor,
  customData
}) => ({
  anchor,
  url,
  rel: rel && Object.entries(rel).flatMap(([key, value]) => value ? key : []).join(" "),
  target: target && "_" + target.toLowerCase(),
  customData
});
const getRangeStyle = (range) => {
  try {
    const style = JSON.parse(range.style);
    return { styleKey: Object.keys(style)[0], styleValue: Object.values(style)[0] };
  } catch (e) {
    return { styleKey: range.style, styleValue: range.style };
  }
};
const removeOverlappingRangesWithSameStyle = (ranges) => {
  const isOverlapping = (a, b) => a.styleKey === b.styleKey && a.styleValue === b.styleValue && a.offset <= b.offset + b.length && a.offset + a.length >= b.offset;
  return ranges.map((range) => __spreadValues$d(__spreadValues$d({}, range), getRangeStyle(range))).reduce((acc, range) => {
    const filteredRanges = acc.filter((r) => {
      return !(range.styleKey === r.styleKey && r.offset >= range.offset && r.offset + r.length <= range.offset + range.length);
    });
    return mergeRangeWithList(filteredRanges, range, isOverlapping);
  }, []).reduce((acc, range) => {
    return adjustAndAddRange(acc, range);
  }, []).map((_a) => {
    var _b = _a, range = __objRest$5(_b, ["styleKey", "styleValue"]);
    return range;
  });
};
const adjustAndAddRange = (existingRanges, newRange) => {
  const isOverlapping = (a, b) => (a.styleKey === b.styleKey || `NOT_${a.styleKey}` === b.styleKey || a.styleKey === `NOT_${b.styleKey}`) && a.offset <= b.offset + b.length && a.offset + a.length >= b.offset;
  const adjust = (existing, newR) => {
    if (isOverlapping(existing, newR)) {
      if (existing.offset === newR.offset) {
        return __spreadProps$b(__spreadValues$d({}, existing), {
          offset: newR.offset + newR.length,
          length: existing.length - newR.length
        });
      } else if (existing.offset > newR.offset) {
        const overlapLength = newR.offset + newR.length - existing.offset;
        return __spreadProps$b(__spreadValues$d({}, existing), {
          offset: existing.offset + overlapLength,
          length: existing.length - overlapLength
        });
      } else {
        return __spreadProps$b(__spreadValues$d({}, existing), { length: newR.offset - existing.offset });
      }
    }
    return existing;
  };
  const adjustedRanges = existingRanges.map((range) => adjust(range, newRange)).filter((range) => range.length > 0);
  adjustedRanges.push(newRange);
  return adjustedRanges;
};
const mergeOverlappingEntityRanges = (entityRanges) => {
  const isOverlapping = (a, b) => a.key === b.key && a.offset <= b.offset + b.length && a.offset + a.length >= b.offset;
  return entityRanges.reduce(
    (acc, range) => mergeRangeWithList(acc, range, isOverlapping),
    []
  );
};
const mergeRangeWithList = (ranges, newRange, isOverlapping) => {
  const mergeRanges = (a, b) => __spreadProps$b(__spreadValues$d({}, a), {
    offset: Math.min(a.offset, b.offset),
    length: Math.max(a.offset + a.length, b.offset + b.length) - Math.min(a.offset, b.offset)
  });
  const result = ranges.reduce(
    (acc, currentRange) => {
      if (isOverlapping(acc.currentMerging, currentRange)) {
        acc.currentMerging = mergeRanges(acc.currentMerging, currentRange);
        return acc;
      }
      acc.ranges.push(currentRange);
      return acc;
    },
    { ranges: [], currentMerging: newRange }
  );
  result.ranges.push(result.currentMerging);
  return result.ranges;
};
const generateRangeMap = (ranges) => {
  const rangeMap = {};
  ranges.forEach((_a) => {
    var _b = _a, { offset, length } = _b, props = __objRest$5(_b, ["offset", "length"]);
    rangeMap[offset] = [...rangeMap[offset] || [], __spreadProps$b(__spreadValues$d({ action: "start" }, props), { length })];
    rangeMap[offset + length] = [
      ...rangeMap[offset + length] || [],
      __spreadProps$b(__spreadValues$d({ action: "end" }, props), { length })
    ];
  });
  const normalizedRangeMap = normalizeRangeMap(rangeMap);
  if (!normalizedRangeMap[0]) {
    normalizedRangeMap[0] = [];
  }
  return normalizedRangeMap;
};
const getRangeEntityId = (entry) => {
  if ("key" in entry) {
    return entry.key;
  }
  return entry.style;
};
const isEntryOverlapping = (current, next) => {
  return getRangeEntityId(current) === getRangeEntityId(next) && current.action === "end" && next.action === "start" && // Ranges of length 1 are not overlapping
  current.length !== 1 && next.length !== 1;
};
const getStyleKeyVariation = (entry) => {
  if ("key" in entry) {
    return entry.key;
  }
  try {
    const style = JSON.parse(entry.style);
    return Object.keys(style)[0];
  } catch (e) {
    return entry.style;
  }
};
const getStyleKeyValue = (entry) => {
  if ("key" in entry) {
    return entry.key;
  }
  return entry.style;
};
const mergeAdjacentRanges = (rangeMap) => {
  const newRangeMap = cloneDeep(rangeMap);
  Object.keys(newRangeMap).forEach((key) => {
    const intKey = parseInt(key);
    if (!newRangeMap[intKey + 1]) {
      return;
    }
    const hasMultipleSameStyleEntries = newRangeMap[intKey].some((current) => {
      return newRangeMap[intKey].some(
        (next) => current === next ? false : getStyleKeyVariation(current) === getStyleKeyVariation(next)
      );
    });
    if (hasMultipleSameStyleEntries) {
      return;
    }
    const currentRangeBeforeUpdate = newRangeMap[intKey];
    newRangeMap[intKey] = newRangeMap[intKey].filter((current) => {
      return newRangeMap[intKey + 1].every((next) => !isEntryOverlapping(current, next));
    });
    newRangeMap[intKey + 1] = newRangeMap[intKey + 1].filter((next) => {
      return currentRangeBeforeUpdate.every((current) => !isEntryOverlapping(current, next));
    });
  });
  return Object.entries(newRangeMap).reduce((acc, [key, value]) => {
    return __spreadProps$b(__spreadValues$d({}, acc), {
      [key]: value.map((v) => __spreadProps$b(__spreadValues$d({}, v), { length: void 0 }))
    });
  }, {});
};
const moveEndOfRanges = (rangeMap) => {
  const newRangeMap = cloneDeep(rangeMap);
  Object.keys(newRangeMap).reverse().forEach((key, index, allKeys) => {
    for (const current of newRangeMap[key]) {
      if (current.action !== "end") {
        continue;
      }
      const currentStyleKey = getStyleKeyVariation(current);
      let isMovable = false;
      let hasValidStart = false;
      const sameStyleStartInSameKey = newRangeMap[key].find((entry) => {
        return getStyleKeyValue(entry) === getStyleKeyValue(current) && entry.action === "start";
      });
      if (sameStyleStartInSameKey) {
        newRangeMap[key] = newRangeMap[key].filter(
          (entry) => ![current, sameStyleStartInSameKey].includes(entry)
        );
        continue;
      }
      for (let i = index + 1; i < allKeys.length; i++) {
        const prevKey = allKeys[i];
        hasValidStart = newRangeMap[prevKey].some((prev) => {
          return prev.action === "start" && getRangeEntityId(current) === getRangeEntityId(prev);
        });
        if (hasValidStart) {
          break;
        }
        isMovable = newRangeMap[prevKey].some((prev) => {
          const prevStyleKey = getStyleKeyVariation(prev);
          return prev.action === "start" && currentStyleKey === prevStyleKey && getRangeEntityId(current) !== getRangeEntityId(prev);
        });
        if (isMovable) {
          newRangeMap[prevKey].push(current);
          break;
        }
      }
      if (hasValidStart) {
        continue;
      }
      if (isMovable) {
        newRangeMap[key] = newRangeMap[key].filter((entry) => entry !== current);
      }
    }
  });
  return newRangeMap;
};
const normalizeRangeMap = (rangeMap) => {
  const newRangeMap = moveEndOfRanges(mergeAdjacentRanges(rangeMap));
  Object.keys(newRangeMap).forEach((key) => {
    var _a;
    if (((_a = newRangeMap[key]) == null ? void 0 : _a.length) === 0) {
      delete newRangeMap[key];
    }
  });
  return newRangeMap;
};

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var BlockType = /* @__PURE__ */ ((BlockType2) => {
  BlockType2["Unstyled"] = "unstyled";
  BlockType2["HeaderOne"] = "header-one";
  BlockType2["HeaderTwo"] = "header-two";
  BlockType2["HeaderThree"] = "header-three";
  BlockType2["HeaderFour"] = "header-four";
  BlockType2["HeaderFive"] = "header-five";
  BlockType2["HeaderSix"] = "header-six";
  BlockType2["UnorderedListItem"] = "unordered-list-item";
  BlockType2["OrderedListItem"] = "ordered-list-item";
  BlockType2["Blockquote"] = "blockquote";
  BlockType2["CodeBlock"] = "code-block";
  BlockType2["Atomic"] = "atomic";
  return BlockType2;
})(BlockType || {});
var HeaderLevel = /* @__PURE__ */ ((HeaderLevel2) => {
  HeaderLevel2[HeaderLevel2["header-one"] = 1] = "header-one";
  HeaderLevel2[HeaderLevel2["header-two"] = 2] = "header-two";
  HeaderLevel2[HeaderLevel2["header-three"] = 3] = "header-three";
  HeaderLevel2[HeaderLevel2["header-four"] = 4] = "header-four";
  HeaderLevel2[HeaderLevel2["header-five"] = 5] = "header-five";
  HeaderLevel2[HeaderLevel2["header-six"] = 6] = "header-six";
  return HeaderLevel2;
})(HeaderLevel || {});
const FROM_DRAFT_LIST_TYPE = {
  ["unordered-list-item" /* UnorderedListItem */]: Node_Type.BULLETED_LIST,
  ["ordered-list-item" /* OrderedListItem */]: Node_Type.ORDERED_LIST
};
const TO_DRAFT_LIST_TYPE = fromEntries(
  Object.entries(FROM_DRAFT_LIST_TYPE).map(([key, value]) => [value, key])
);
const TO_RICOS_NODE_TYPE = {
  [LINK_BUTTON_TYPE]: Node_Type.BUTTON,
  [ACTION_BUTTON_TYPE]: Node_Type.BUTTON,
  [DIVIDER_TYPE]: Node_Type.DIVIDER,
  [FILE_UPLOAD_TYPE]: Node_Type.FILE,
  [GALLERY_TYPE]: Node_Type.GALLERY,
  [GIPHY_TYPE]: Node_Type.GIF,
  [HTML_TYPE]: Node_Type.HTML,
  [IMAGE_TYPE]: Node_Type.IMAGE,
  [IMAGE_TYPE_LEGACY]: Node_Type.IMAGE,
  [COLLAPSIBLE_LIST_TYPE]: Node_Type.COLLAPSIBLE_LIST,
  [LINK_PREVIEW_TYPE]: Node_Type.LINK_PREVIEW,
  [MAP_TYPE]: Node_Type.MAP,
  [APP_EMBED_TYPE]: Node_Type.APP_EMBED,
  [VIDEO_TYPE]: Node_Type.VIDEO,
  [AUDIO_TYPE]: Node_Type.AUDIO,
  [VIDEO_TYPE_LEGACY]: Node_Type.VIDEO,
  [POLL_TYPE]: Node_Type.POLL,
  [TABLE_TYPE]: Node_Type.TABLE,
  [EMBED_TYPE]: Node_Type.EMBED,
  [EXTERNAL]: Node_Type.EXTERNAL
};
const DUPLICATE_KEYS = [IMAGE_TYPE_LEGACY, VIDEO_TYPE_LEGACY];
const FROM_RICOS_ENTITY_TYPE = fromEntries(
  Object.entries(TO_RICOS_NODE_TYPE).filter(([key]) => !DUPLICATE_KEYS.includes(key)).map(([key, value]) => [value, key])
);
const TO_RICOS_DECORATION_TYPE = {
  BOLD: Decoration_Type.BOLD,
  ITALIC: Decoration_Type.ITALIC,
  UNDERLINE: Decoration_Type.UNDERLINE,
  [SPOILER_TYPE]: Decoration_Type.SPOILER,
  [ANCHOR_TYPE]: Decoration_Type.ANCHOR,
  [MENTION_TYPE]: Decoration_Type.MENTION,
  [LINK_TYPE]: Decoration_Type.LINK,
  [EXTERNAL]: Decoration_Type.EXTERNAL
};
const TO_RICOS_INLINE_STYLE_TYPE = {
  BOLD: { type: Decoration_Type.BOLD, fontWeightValue: 700 },
  NOT_BOLD: { type: Decoration_Type.BOLD, fontWeightValue: 400 },
  ITALIC: { type: Decoration_Type.ITALIC, italicData: true },
  NOT_ITALIC: { type: Decoration_Type.ITALIC, italicData: false },
  UNDERLINE: { type: Decoration_Type.UNDERLINE, underlineData: true },
  NOT_UNDERLINE: { type: Decoration_Type.UNDERLINE, underlineData: false }
};
const TO_RICOS_PLUGIN_TYPE = __spreadValues$c(__spreadValues$c({}, TO_RICOS_NODE_TYPE), TO_RICOS_DECORATION_TYPE);
const FROM_RICOS_DECORATION_TYPE = fromEntries(
  Object.entries(TO_RICOS_DECORATION_TYPE).map(([key, value]) => [value, key])
);
const ENTITY_DECORATION_TO_MUTABILITY = {
  [ANCHOR_TYPE]: "MUTABLE",
  [LINK_TYPE]: "MUTABLE",
  [MENTION_TYPE]: "SEGMENTED",
  EMOJI_TYPE: "IMMUTABLE"
};
const DRAFT_BLOCK_TYPE_TO_DATA_FIELD = {
  ["unstyled" /* Unstyled */]: "paragraphData",
  ["unordered-list-item" /* UnorderedListItem */]: "paragraphData",
  ["ordered-list-item" /* OrderedListItem */]: "paragraphData",
  ["header-one" /* HeaderOne */]: "headingData",
  ["header-two" /* HeaderTwo */]: "headingData",
  ["header-three" /* HeaderThree */]: "headingData",
  ["header-four" /* HeaderFour */]: "headingData",
  ["header-five" /* HeaderFive */]: "headingData",
  ["header-six" /* HeaderSix */]: "headingData",
  ["code-block" /* CodeBlock */]: "codeBlockData",
  ["blockquote" /* Blockquote */]: "paragraphData"
};
const DRAFT_PLUGIN_TYPE_TO_DATA_FIELD = fromEntries(
  Object.entries(TO_RICOS_NODE_TYPE).map(([key, value]) => [
    key,
    RICOS_NODE_TYPE_TO_DATA_FIELD[value]
  ])
);
const ENTITY_DECORATION_TO_DATA_FIELD = {
  [ANCHOR_TYPE]: "anchorData",
  [LINK_TYPE]: "linkData",
  [MENTION_TYPE]: "mentionData",
  EMOJI_TYPE: "emojiData"
};
const DECORATION_TO_DATA_FIELD = {
  COLOR: "colorData",
  FONT_SIZE: "fontSizeData"
};
const TO_RICOS_DECORATION_DATA_FIELD = __spreadValues$c(__spreadValues$c({}, ENTITY_DECORATION_TO_DATA_FIELD), DECORATION_TO_DATA_FIELD);
const TO_RICOS_DATA_FIELD = __spreadValues$c(__spreadValues$c(__spreadValues$c({}, TO_RICOS_DECORATION_DATA_FIELD), DRAFT_PLUGIN_TYPE_TO_DATA_FIELD), DRAFT_BLOCK_TYPE_TO_DATA_FIELD);

const TO_RICOS_DATA = {
  [LINK_BUTTON_TYPE]: ButtonData,
  [ACTION_BUTTON_TYPE]: ButtonData,
  [DIVIDER_TYPE]: DividerData,
  [FILE_UPLOAD_TYPE]: FileData,
  [GALLERY_TYPE]: GalleryData,
  [GIPHY_TYPE]: GIFData,
  [HTML_TYPE]: HTMLData,
  [IMAGE_TYPE]: ImageData,
  [IMAGE_TYPE_LEGACY]: ImageData,
  [LINK_PREVIEW_TYPE]: LinkPreviewData,
  [MAP_TYPE]: MapData,
  [APP_EMBED_TYPE]: AppEmbedData,
  [VIDEO_TYPE]: VideoData,
  [VIDEO_TYPE_LEGACY]: VideoData,
  [AUDIO_TYPE]: AudioData,
  [POLL_TYPE]: PollData,
  [EMBED_TYPE]: EmbedData,
  [COLLAPSIBLE_LIST_TYPE]: CollapsibleListData,
  [TABLE_TYPE]: TableData,
  [EXTERNAL]: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fromJSON(data) {
      return data;
    }
  }
};

/**
 * Export.
 */

var toNoCase_1 = toNoCase;

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g;

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g;

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}

var clean = toNoCase_1;

/**
 * Export.
 */

var toSpaceCase_1 = toSpaceCase;

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}

var toSpace = toSpaceCase_1;

/**
 * Export.
 */

var toSnakeCase_1 = toSnakeCase;

/**
 * Convert a `string` to snake case.
 *
 * @param {String} string
 * @return {String}
 */

function toSnakeCase(string) {
  return toSpace(string).replace(/\s/g, '_')
}

var snake = toSnakeCase_1;

/**
 * Export.
 */

var toConstantCase_1 = toConstantCase;

/**
 * Convert a `string` to constant case.
 *
 * @param {String} string
 * @return {String}
 */

function toConstantCase(string) {
  return snake(string).toUpperCase()
}

/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */
function fromPredicate$1(F) {
    return function (predicate, onFalse) { return function (a) {
        return F.fromEither(predicate(a) ? right$1(a) : left$1(onFalse(a)));
    }; };
}

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: Array<A>) => Array<B>`.
 * In practice it applies the base function to each element of the array and collects the
 * results in a new array.
 *
 * @example
 * import { map } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (n: number) => n * 2;
 * assert.deepStrictEqual(pipe([1, 2, 3], map(f)), [2, 4, 6]);
 *
 * @category Functor
 * @since 2.0.0
 */
var map$1 = function (f) { return function (fa) { return fa.map(function (a) { return f(a); }); }; };

// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the monoid `empty` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([1, 2, 3]), 6)
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([]), 0)
 *
 * @since 2.10.0
 */
var concatAll = function (M) { return concatAll$1(M)(M.empty); };

/**
 * Test whether a `ReadonlyRecord` is empty.
 *
 * @example
 * import { isEmpty } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(isEmpty({}), true);
 * assert.deepStrictEqual(isEmpty({ a: 3 }), false);
 * @since 2.5.0
 */
var isEmpty = function (r) {
    for (var k in r) {
        if (has.call(r, k)) {
            return false;
        }
    }
    return true;
};
/**
 * @since 2.5.0
 */
var empty = {};
function getMonoid$1(S) {
    return {
        concat: function (first, second) {
            if (isEmpty(first)) {
                return second;
            }
            if (isEmpty(second)) {
                return first;
            }
            var r = Object.assign({}, first);
            for (var k in second) {
                if (has.call(second, k)) {
                    r[k] = has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
                }
            }
            return r;
        },
        empty: empty
    };
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Returns a `Monoid` instance for `Record`s, given a `Semigroup`
 * instance for the base type.
 * The `Monoid` makes the union of two `Record`s comining the
 * overlapping entries with the provided `Semigroup`.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 * import { getMonoid } from 'fp-ts/Record'
 *
 * const M = getMonoid(SemigroupSum);
 * assert.deepStrictEqual(M.concat({ foo: 123, bar: 234 }, { foo: 456, baz: 567 }), { foo: 579 , bar: 234, baz: 567 });
 *
 * @category instances
 * @since 2.0.0
 */
var getMonoid = getMonoid$1;

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @category destructors
 * @since 2.5.0
 */
function fst$1(ea) {
    return ea[0];
}
/**
 * @category destructors
 * @since 2.5.0
 */
function snd$1(ea) {
    return ea[1];
}

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @category destructors
 * @since 2.0.0
 */
var fst = fst$1;
/**
 * @category destructors
 * @since 2.0.0
 */
var snd = snd$1;
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category Bifunctor
 * @since 2.0.0
 */
var bimap = function (f, g) { return function (fa) { return [g(fst(fa)), f(snd(fa))]; }; };

// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure.
 *
 * @category constructors
 * @since 2.0.0
 */
var left = left$1;
/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure.
 *
 * @category constructors
 * @since 2.0.0
 */
var right = right$1;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var URI = 'Either';
/**
 * Semigroup returning the left-most non-`Left` value. If both operands are `Right`s then the inner values are
 * concatenated using the provided `Semigroup`
 *
 * @example
 * import { getSemigroup, left, right } from 'fp-ts/Either'
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * const S = getSemigroup<string, number>(SemigroupSum)
 * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
 * assert.deepStrictEqual(S.concat(left('a'), right(2)), right(2))
 * assert.deepStrictEqual(S.concat(right(1), left('b')), right(1))
 * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
 *
 * @category instances
 * @since 2.0.0
 */
var getSemigroup = function (S) { return ({
    concat: function (x, y) { return (isLeft(y) ? x : isLeft(x) ? y : right(S.concat(x.right, y.right))); }
}); };
/**
 * @category instance operations
 * @since 2.0.0
 */
var map = function (f) { return function (fa) {
    return isLeft(fa) ? fa : right(f(fa.right));
}; };
/**
 * Less strict version of [`chain`](#chain).
 *
 * @category instance operations
 * @since 2.6.0
 */
var chainW = function (f) { return function (ma) {
    return isLeft(ma) ? ma : f(ma.right);
}; };
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category instance operations
 * @since 2.0.0
 */
var chain = chainW;
/**
 * @category instances
 * @since 2.10.0
 */
var FromEither = {
    URI: URI,
    fromEither: identity
};
/**
 * @example
 * import { fromPredicate, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     -1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   left('error')
 * )
 *
 * @category constructors
 * @since 2.0.0
 */
var fromPredicate = 
/*#__PURE__*/
fromPredicate$1(FromEither);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Returns `true` if the either is an instance of `Left`, `false` otherwise.
 *
 * @category refinements
 * @since 2.0.0
 */
var isLeft = isLeft$1;
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.10.0
 */
var matchW = function (onLeft, onRight) { return function (ma) {
    return isLeft(ma) ? onLeft(ma.left) : onRight(ma.right);
}; };
/**
 * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the first function,
 * if the value is a `Right` the inner value is applied to the second function.
 *
 * @example
 * import { match, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * function onLeft(errors: Array<string>): string {
 *   return `Errors: ${errors.join(', ')}`
 * }
 *
 * function onRight(value: number): string {
 *   return `Ok: ${value}`
 * }
 *
 * assert.strictEqual(
 *   pipe(
 *     right(1),
 *     match(onLeft, onRight)
 *   ),
 *   'Ok: 1'
 * )
 * assert.strictEqual(
 *   pipe(
 *     left(['error 1', 'error 2']),
 *     match(onLeft, onRight)
 *   ),
 *   'Errors: error 1, error 2'
 * )
 *
 * @category destructors
 * @since 2.10.0
 */
var match = matchW;
/**
 * Alias of [`match`](#match).
 *
 * @category destructors
 * @since 2.0.0
 */
var fold = match;
/**
 * Constructs a new `Either` from a function that might throw.
 *
 * See also [`tryCatchK`](#trycatchk).
 *
 * @example
 * import * as E from 'fp-ts/Either'
 *
 * const unsafeHead = <A>(as: ReadonlyArray<A>): A => {
 *   if (as.length > 0) {
 *     return as[0]
 *   } else {
 *     throw new Error('empty array')
 *   }
 * }
 *
 * const head = <A>(as: ReadonlyArray<A>): E.Either<Error, A> =>
 *   E.tryCatch(() => unsafeHead(as), e => (e instanceof Error ? e : new Error('unknown error')))
 *
 * assert.deepStrictEqual(head([]), E.left(new Error('empty array')))
 * assert.deepStrictEqual(head([1, 2, 3]), E.right(1))
 *
 * @category interop
 * @since 2.0.0
 */
var tryCatch = function (f, onThrow) {
    try {
        return right(f());
    }
    catch (e) {
        return left(onThrow(e));
    }
};

const firstRight = (candidate, defaultT, resolvers) => {
  const firstRightSemi = getSemigroup(first());
  const concatFirstRightSemi = concatAll$1(firstRightSemi)(left(defaultT));
  return pipe$1(
    concatFirstRightSemi(
      pipe$1(
        resolvers,
        map$1(
          (r) => pipe$1(
            candidate,
            fromPredicate(r[0], () => defaultT),
            map(r[1])
          )
        )
      )
    ),
    fold(identity, identity)
  );
};
const stringifyWithReplace = (replacer, space = 2) => (a) => tryCatch(() => {
  const s = JSON.stringify(a, replacer, space);
  if (typeof s !== "string") {
    throw new Error("Converting unsupported structure to JSON");
  }
  return s;
}, identity);

var __defProp$b = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
const valueM = getMonoid(first());
const toRecord$1 = ([k, v]) => ({ [k]: v });
const toStruct = (fields) => ({ fields });
const toListValue = (values) => ({ values });
const defaultValue = {
  numberValue: void 0,
  nullValue: void 0,
  stringValue: void 0,
  boolValue: void 0
};
const convertJsonToList = (json) => pipe$1(json, map$1(convertJsonToValue), toListValue);
const convertJsonToValue = (json) => firstRight(json, __spreadProps$a(__spreadValues$b({}, defaultValue), { nullValue: NullValue.NULL_VALUE }), [
  [(json2) => typeof json2 === "number", (json2) => __spreadProps$a(__spreadValues$b({}, defaultValue), { numberValue: json2 })],
  [(json2) => typeof json2 === "string", (json2) => __spreadProps$a(__spreadValues$b({}, defaultValue), { stringValue: json2 })],
  [(json2) => typeof json2 === "boolean", (json2) => __spreadProps$a(__spreadValues$b({}, defaultValue), { boolValue: json2 })],
  [
    (json2) => Array.isArray(json2),
    (json2) => __spreadProps$a(__spreadValues$b({}, defaultValue), { listValue: convertJsonToList(json2) })
  ],
  [
    (json2) => isObject(json2),
    (json2) => __spreadProps$a(__spreadValues$b({}, defaultValue), { structValue: convertJsonToStruct(json2) })
  ]
]);
const convertJsonToStruct = flow(
  Object.entries,
  map$1(bimap(convertJsonToValue, identity)),
  map$1(toRecord$1),
  concatAll(valueM),
  toStruct
);

var __defProp$a = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const supportedContainerDataAlignments = [
  PluginContainerData_Alignment.CENTER,
  PluginContainerData_Alignment.LEFT,
  PluginContainerData_Alignment.RIGHT
];
const convertBlockDataToRicos = (type, data) => {
  const newData = cloneDeep(data);
  const converters = {
    [VIDEO_TYPE]: convertVideoData$1,
    [VIDEO_TYPE_LEGACY]: convertLegacyVideoData,
    [AUDIO_TYPE]: convertAudioData$1,
    [DIVIDER_TYPE]: convertDividerData$1,
    [FILE_UPLOAD_TYPE]: convertFileData$1,
    [GIPHY_TYPE]: convertGIFData$1,
    [IMAGE_TYPE]: convertImageData$1,
    [IMAGE_TYPE_LEGACY]: convertImageData$1,
    [POLL_TYPE]: convertPollData$1,
    [APP_EMBED_TYPE]: convertAppEmbedData$1,
    [LINK_PREVIEW_TYPE]: convertLinkPreviewData$1,
    [MENTION_TYPE]: convertMentionData$1,
    [LINK_BUTTON_TYPE]: convertButtonData$1,
    [ACTION_BUTTON_TYPE]: convertButtonData$1,
    [COLLAPSIBLE_LIST_TYPE]: convertCollapsibleListData$1,
    [HTML_TYPE]: convertHTMLData$1,
    [MAP_TYPE]: convertMapData$1,
    [EMBED_TYPE]: convertEmbedData$1,
    [LINK_TYPE]: convertLinkData$1,
    [TABLE_TYPE]: convertTableData$1,
    [GALLERY_TYPE]: convertGalleryData$1,
    [EXTERNAL]: convertExternalData$1
  };
  let blockType = type;
  if (type === LINK_PREVIEW_TYPE && data.html) {
    blockType = EMBED_TYPE;
  }
  if ([IMAGE_TYPE_LEGACY, IMAGE_TYPE].includes(type) && !newData.config) {
    newData.config = {};
  }
  if (newData.config && blockType !== EXTERNAL) {
    convertContainerData$1(newData, blockType);
  }
  if (blockType in converters) {
    const convert = converters[blockType];
    convert(newData, blockType);
  }
  const fromJSON = (data2) => {
    const pluginDataMethods = TO_RICOS_DATA[blockType];
    return (pluginDataMethods == null ? void 0 : pluginDataMethods.fromJSON(data2)) || data2;
  };
  return fromJSON(newData);
};
const convertContainerData$1 = (data, blockType) => {
  var _a, _b;
  const { size, alignment, width, spoiler, height, textWrap = WRAP } = data.config || {};
  const { enabled, description, buttonContent } = spoiler || {};
  const newSpoiler = spoiler && {
    enabled: enabled || false,
    description,
    buttonText: buttonContent
  };
  const normalizedAlignment = alignment == null ? void 0 : alignment.toUpperCase();
  data.containerData = {
    alignment: normalizedAlignment && supportedContainerDataAlignments.includes(
      normalizedAlignment
    ) ? normalizedAlignment : null,
    spoiler: newSpoiler,
    textWrap: textWrap !== NO_WRAP
  };
  typeof height === "number" && (data.containerData.height = { custom: parseInt(height.toString(), 10) });
  if (typeof width === "number" && (blockType !== IMAGE_TYPE || !size || size === "inline")) {
    data.containerData.width = { custom: parseInt(width.toString(), 10) };
  } else if (size && size !== "inline") {
    data.containerData.width = { size: toConstantCase_1(size) };
  }
  if (blockType === ACTION_BUTTON_TYPE || blockType === LINK_BUTTON_TYPE) {
    if (width === "fit-content") {
      data.containerData.width = { size: "ORIGINAL" };
    }
  }
  if (blockType === IMAGE_TYPE && ((_a = data.containerData.width) == null ? void 0 : _a.size) === "ORIGINAL" && ((_b = data.src) == null ? void 0 : _b.width) && isNumber(data.src.width) && data.src.width > 350) {
    data.containerData.alignment = data.containerData.alignment || "CENTER";
  }
};
const convertVideoData$1 = (data) => {
  if (typeof data.src === "string" && data.src) {
    data.video = { src: { url: data.src } };
    const {
      oembed,
      thumbnail_url,
      width: thumbnail_width,
      height: thumbnail_height,
      title
    } = data.metadata || {};
    let src, width, height;
    if (oembed) {
      const { thumbnail_url: thumbnail_url2, thumbnail_width: thumbnail_width2, thumbnail_height: thumbnail_height2 } = oembed;
      src = thumbnail_url2 ? { url: thumbnail_url2 } : void 0;
      width = thumbnail_width2;
      height = thumbnail_height2;
    } else {
      src = thumbnail_url ? { url: thumbnail_url } : void 0;
      width = thumbnail_width;
      height = thumbnail_height;
    }
    const titleResolved = oembed ? oembed.title : title;
    titleResolved && (data.title = titleResolved);
    data.thumbnail = src || width || height ? { src, width, height } : void 0;
  } else if (typeof data.src === "object" && data.src.pathname) {
    data.video = { src: { id: data.src.pathname } };
    data.thumbnail = data.src.thumbnail ? {
      src: { id: data.src.thumbnail.pathname },
      width: data.src.thumbnail.width,
      height: data.src.thumbnail.height
    } : void 0;
  }
  data.video && (data.video.duration = data.duration);
};
const convertLegacyVideoData = (data) => {
  const { url, oembed, src } = data;
  if (url != null ? url : src) {
    data.video = { src: { url: url != null ? url : src } };
  }
  delete data.url;
  if (oembed) {
    const { thumbnail_url, thumbnail_width, thumbnail_height, title } = oembed;
    if (thumbnail_url) {
      data.thumbnail = {
        src: { url: thumbnail_url },
        width: thumbnail_width ? Number(thumbnail_width) : void 0,
        height: thumbnail_height ? Number(thumbnail_height) : void 0
      };
    }
    if (title) {
      data.title = oembed.title;
    }
    delete data.oembed;
  }
  data.containerData = {
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true
  };
};
const convertAudioData$1 = (data) => {
  const { coverImage } = data;
  if (coverImage) {
    const { file_name, width, height } = coverImage;
    data.coverImage = { file_name, src: { id: file_name }, width, height };
  }
};
const convertGalleryStyles$1 = (styles) => {
  var _a, _b;
  styles.layout = {};
  styles.item = {};
  styles.thumbnails = {};
  has$1(styles, "galleryLayout") && (styles.layout.type = styles.galleryLayout);
  has$1(styles, "oneRow") && (styles.layout.horizontalScroll = styles.oneRow);
  has$1(styles, "isVertical") && (styles.layout.orientation = styles.isVertical ? "COLUMNS" : "ROWS");
  has$1(styles, "m_numberOfImagesPerRow") && (styles.layout.mobileNumberOfColumns = styles.m_numberOfImagesPerRow);
  if (has$1(styles, "m_numberOfImagesPerRow") && !isNaN(parseInt(styles.m_numberOfImagesPerRow, 10))) {
    styles.layout.mobileNumberOfColumns = styles.m_numberOfImagesPerRow;
  }
  if (has$1(styles, "gallerySizePx") && !isNaN(parseInt(styles.gallerySizePx, 10))) {
    styles.item.targetSize = styles.gallerySizePx;
  }
  if (has$1(styles, "numberOfImagesPerRow") && !isNaN(parseInt(styles.numberOfImagesPerRow, 10))) {
    styles.layout.numberOfColumns = styles.numberOfImagesPerRow;
  }
  if (has$1(styles, "cubeRatio")) {
    if (typeof styles.cubeRatio === "string") {
      const [x, y] = styles.cubeRatio.split("/");
      if (!(Number.isNaN(parseInt(x, 10)) && Number.isNaN(parseInt(y, 10)))) {
        styles.item.ratio = Math.trunc(parseInt(x, 10) / parseInt(y, 10) * 100) / 100;
      }
    } else {
      styles.item.ratio = styles.cubeRatio;
    }
  }
  const cubeType = (_a = styles == null ? void 0 : styles.cubeType) == null ? void 0 : _a.toUpperCase();
  ["FIT", "FILL"].includes(cubeType) && (styles.item.crop = cubeType);
  if (has$1(styles, "imageMargin") && !isNaN(parseInt(styles.imageMargin, 10))) {
    styles.item.spacing = styles.imageMargin;
  }
  const thumbnailPlacement = (_b = styles == null ? void 0 : styles.galleryThumbnailsAlignment) == null ? void 0 : _b.toUpperCase();
  styles.thumbnails.placement = ["TOP", "BOTTOM", "LEFT", "RIGHT"].includes(thumbnailPlacement) ? thumbnailPlacement : "NONE";
  if (has$1(styles, "thumbnailSpacings") && !isNaN(parseInt(styles.thumbnailSpacings, 10))) {
    styles.thumbnails.spacing = Math.trunc(styles.thumbnailSpacings);
  }
  return styles;
};
const convertGalleryItem$1 = (item) => {
  const {
    url,
    metadata: { type = "image", poster, height, width, link, title, altText }
  } = item;
  item[type] = { media: { src: { url }, height, width } };
  title && (item.title = title);
  altText && (item.altText = altText);
  if (type === "video" && poster) {
    const src = { url: poster.url || poster };
    item.video.thumbnail = { src, height: poster.height || height, width: poster.width || width };
  }
  type === "image" && link && (item.image.link = createLink(link));
  return item;
};
const convertGalleryData$1 = (data) => {
  has$1(data, "items") && (data.items = data.items.map((item) => convertGalleryItem$1(item)));
  has$1(data, "styles") && (data.options = convertGalleryStyles$1(data.styles));
};
const convertDividerData$1 = (data) => {
  var _a, _b, _c, _d, _e;
  has$1(data, "type") && (data.lineStyle = (_a = data.type) == null ? void 0 : _a.toUpperCase());
  has$1(data, "config.size") && (data.width = (_c = (_b = data.config) == null ? void 0 : _b.size) == null ? void 0 : _c.toUpperCase());
  has$1(data, "config.alignment") && (data.alignment = (_e = (_d = data.config) == null ? void 0 : _d.alignment) == null ? void 0 : _e.toUpperCase());
  data.containerData.width = { size: PluginContainerData_Width_Type.CONTENT };
};
const convertExternalData$1 = (data) => {
  data.fields = convertJsonToStruct(data).fields;
};
const convertImageData$1 = (data) => {
  var _a, _b;
  if (isNaN(parseInt(data.width))) {
    delete data.width;
  }
  if (isNaN(parseInt(data.height))) {
    delete data.height;
  }
  if (typeof data.src === "string") {
    data.image = {
      src: { source: "static", url: data.src },
      width: ensureValidNumber(data.width),
      height: ensureValidNumber(data.height)
    };
  } else if (typeof data.src === "object" && data.src !== null) {
    if ("url" in data.src && typeof data.src.url === "string") {
      const { url, width, height } = data.src || {};
      data.image = {
        src: { url },
        width: ensureValidNumber(width),
        height: ensureValidNumber(height)
      };
    } else if ("file_name" in data.src && typeof data.src.file_name === "string" && data.src.file_name) {
      const { file_name, width, height } = data.src || {};
      data.image = {
        src: { id: file_name },
        width: ensureValidNumber(width),
        height: ensureValidNumber(height)
      };
    }
  }
  const { link, anchor } = data.config || {};
  data.link = (link || anchor) && createLink(__spreadProps$9(__spreadValues$a({}, link), { anchor }));
  data.altText = (_a = data.metadata) == null ? void 0 : _a.alt;
  data.caption = (_b = data.metadata) == null ? void 0 : _b.caption;
};
const convertGIFData$1 = (data) => {
  const { gif } = data;
  const {
    originalUrl,
    originalMp4,
    stillUrl,
    downsizedUrl,
    downsizedSmallMp4,
    downsizedStillUrl,
    height,
    width
  } = gif || {};
  data.original = { gif: originalUrl, mp4: originalMp4, still: stillUrl };
  data.downsized = { gif: downsizedUrl, mp4: downsizedSmallMp4, still: downsizedStillUrl };
  data.height = height;
  data.width = width;
  delete data.gif;
};
const convertPollData$1 = (data) => {
  var _a, _b;
  has$1(data, "layout.poll.type") && (data.layout.poll.type = data.layout.poll.type.toUpperCase());
  has$1(data, "layout.poll.direction") && (data.layout.poll.direction = data.layout.poll.direction.toUpperCase());
  if (has$1(data, "layout.option")) {
    data.layout.options = data.layout.option;
    delete data.layout.option;
  }
  if (has$1(data, "design")) {
    const { poll = {}, option = {} } = data.design;
    const { backgroundType, background } = poll;
    const regex = /(\d*)px/;
    const getBackground = (background2) => {
      var _a2, _b2, _c;
      return (background2 == null ? void 0 : background2.angle) ? {
        gradient: {
          angle: background2.angle,
          startColor: (_a2 = background2 == null ? void 0 : background2.start) == null ? void 0 : _a2.toUpperCase(),
          lastColor: (_b2 = background2.end) == null ? void 0 : _b2.toUpperCase()
        }
      } : ((_c = background2 == null ? void 0 : background2.charAt) == null ? void 0 : _c.call(background2, 0)) === "#" ? { color: background2 == null ? void 0 : background2.toUpperCase() } : { image: { src: { url: background2 } } };
    };
    data.design = {
      poll: {
        background: __spreadValues$a({
          type: backgroundType == null ? void 0 : backgroundType.toUpperCase()
        }, getBackground(background)),
        borderRadius: parseInt(((_a = regex.exec(poll.borderRadius)) == null ? void 0 : _a[1]) || "0")
      },
      options: { borderRadius: parseInt(((_b = regex.exec(option.borderRadius)) == null ? void 0 : _b[1]) || "0") }
    };
  }
  has$1(data, "poll.id") && (data.poll.pollId = data.poll.id);
  has$1(data, "poll.createdBy") && (data.poll.creatorId = data.poll.createdBy);
  has$1(data, "poll.mediaId") && (data.poll.image = { src: { url: data.poll.mediaId } });
  has$1(data, "poll.options") && (data.poll.options = data.poll.options.map((_c) => {
    var _d = _c, { mediaId } = _d, rest = __objRest$4(_d, ["mediaId"]);
    return __spreadValues$a({
      image: { src: { url: mediaId } }
    }, rest);
  }));
  if (has$1(data, "poll.settings")) {
    const { multipleVotes, voteRole, resultsVisibility, votersDisplay, votesDisplay } = data.poll.settings;
    const getViewRole = (resultsVisibility2) => resultsVisibility2 === "ALWAYS" ? "EVERYONE" : resultsVisibility2 === "VOTERS_ONLY" ? "VOTERS" : "CREATOR";
    data.poll.settings = {
      permissions: {
        view: getViewRole(resultsVisibility),
        vote: voteRole,
        allowMultipleVotes: multipleVotes
      },
      showVoters: votersDisplay,
      showVotesCount: votesDisplay
    };
  }
  has$1(data, "containerData.width.size") && (data.containerData.width.size = "CONTENT");
};
const convertAppEmbedData$1 = (data) => {
  var _a, _b, _c, _d, _e;
  const {
    id,
    name,
    imageSrc,
    imageHeight,
    imageWidth,
    description,
    pageUrl,
    scheduling,
    location,
    html,
    durations
  } = data.selectedProduct;
  data.url = pageUrl || html && (data.url = (_b = (_a = html.match(/href="[^"]*/g)) == null ? void 0 : _a[0]) == null ? void 0 : _b.slice(6));
  data.itemId = id;
  data.name = name;
  data.imageSrc = imageSrc;
  data.image = { src: { url: imageSrc }, width: imageWidth, height: imageHeight };
  if (data.type === "booking") {
    data.bookingData = { durations: durations || description };
  } else if (data.type === "event") {
    data.eventData = {
      location: location || description && ((_c = description.match(/[^|]*$/)) == null ? void 0 : _c[0]),
      scheduling: scheduling || description && ((_d = description.match(/[^|]+/)) == null ? void 0 : _d[0])
    };
  }
  data.type = (_e = data.type) == null ? void 0 : _e.toUpperCase();
};
const convertLinkPreviewData$1 = (data) => {
  var _a, _b;
  has$1(data, "thumbnail_url") && (data.thumbnailUrl = data.thumbnail_url);
  ((_a = data.config) == null ? void 0 : _a.link) && (data.link = createLink((_b = data.config) == null ? void 0 : _b.link));
};
const convertMentionData$1 = (data) => {
  var _a, _b, _c;
  data.name = (_a = data.mention) == null ? void 0 : _a.name;
  data.slug = (_b = data.mention) == null ? void 0 : _b.slug;
  data.id = (_c = data.mention) == null ? void 0 : _c.id;
  delete data.mention;
};
const convertFileData$1 = (data) => {
  const { url, id, privacy } = data;
  const isPrivate = typeof privacy !== "undefined" ? privacy === "private" : void 0;
  const src = { url, id, private: isPrivate };
  data.src = src;
};
const convertCollapsibleListData$1 = (data) => {
  const { config } = data || {};
  const { expandState, expandOnlyOne, direction, isQapageData } = config || {};
  const getInitialExpandedItems = (expandState2) => {
    if (expandState2 === "expanded") {
      return "ALL";
    }
    if (expandState2 === "collapsed") {
      return "NONE";
    }
    return "FIRST";
  };
  data.initialExpandedItems = getInitialExpandedItems(expandState);
  data.expandOnlyOne = expandOnlyOne;
  data.isQapageData = isQapageData;
  data.direction = direction == null ? void 0 : direction.toUpperCase();
};
const convertButtonData$1 = (data, blockType) => {
  const { settings, design } = data.button || {};
  const { borderRadius, borderWidth, background, color, borderColor } = design || {};
  const { buttonText, url, rel, target } = settings || {};
  data.styles = {
    colors: { text: color, border: borderColor, background },
    border: { radius: borderRadius, width: borderWidth }
  };
  data.type = blockType === ACTION_BUTTON_TYPE ? ButtonData_Type.ACTION : ButtonData_Type.LINK;
  data.text = buttonText;
  if (data.type === ButtonData_Type.LINK && url) {
    data.link = createLink({
      url,
      rel,
      target
    });
  }
};
const convertHTMLData$1 = (data) => {
  const { src, srcType, config } = data;
  config.isAdsense && (data.source = HTMLData_Source.ADSENSE);
  data[srcType] = src;
};
const convertMapData$1 = (data) => {
  const {
    isDraggingAllowed,
    isMarkerShown,
    isStreetViewControlShown,
    isZoomControlShown,
    locationDisplayName,
    isViewControlShown,
    zoom,
    mode
  } = data.mapSettings;
  data.mapSettings.draggable = isDraggingAllowed;
  data.mapSettings.marker = isMarkerShown;
  data.mapSettings.streetViewControl = isStreetViewControlShown;
  data.mapSettings.zoomControl = isZoomControlShown;
  data.mapSettings.locationName = locationDisplayName;
  data.mapSettings.initialZoom = zoom;
  data.mapSettings.mapType = mode == null ? void 0 : mode.toUpperCase();
  if (has$1(data.mapSettings, "isViewControlShown")) {
    data.mapSettings.viewModeControl = isViewControlShown;
  }
};
const convertEmbedData$1 = (data) => {
  var _a, _b;
  const url = (_b = (_a = data.config) == null ? void 0 : _a.link) == null ? void 0 : _b.url;
  url && (data.src = url);
  data.oembed = {
    type: "rich",
    thumbnailUrl: data.thumbnail_url,
    title: data.title,
    description: data.description,
    html: data.html
  };
};
const convertLinkData$1 = (data) => {
  data.link = createLink(data);
};
const convertTableData$1 = (data) => {
  const {
    config: { colsWidth, rowsHeight, colsMinWidth, rowHeader, colHeader }
  } = data;
  const colsWidthRatio = colsWidth.map((width) => parseInt(width, 10));
  data.dimensions = { colsWidthRatio, rowsHeight, colsMinWidth };
  data.rowHeader = rowHeader;
  data.columnHeader = colHeader;
};
const ensureValidNumber = (value) => {
  if (!value) {
    return value;
  }
  const stringValue = value == null ? void 0 : value.toString();
  if (stringValue.endsWith("%")) {
    return 1e3;
  }
  const numberValue = parseInt(value == null ? void 0 : value.toString(), 10);
  if (isNaN(numberValue)) {
    return void 0;
  }
  return numberValue;
};

var __defProp$9 = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
const supportedTextAlignments = [
  TextStyle_TextAlignment.AUTO,
  TextStyle_TextAlignment.LEFT,
  TextStyle_TextAlignment.RIGHT,
  TextStyle_TextAlignment.CENTER,
  TextStyle_TextAlignment.JUSTIFY
];
const normalizeBlockData = (type, data) => {
  switch (type) {
    case DIVIDER_TYPE: {
      data.config = data.config || { textWrap: NO_WRAP };
      return;
    }
    case TABLE_TYPE: {
      data.config.rows = Object.keys(data.config.rows).reduce((acc, key) => {
        const row = data.config.rows[key];
        acc[key] = __spreadProps$8(__spreadValues$9({}, row), {
          columns: row.columns || {
            0: {
              content: {
                blocks: [
                  {
                    key: generateId(),
                    text: "",
                    type: "unstyled",
                    depth: 0,
                    inlineStyleRanges: [],
                    entityRanges: [],
                    data: {}
                  }
                ]
              }
            }
          }
        });
        return acc;
      }, {});
      return;
    }
  }
};
const getEntity = (key, entityMap) => {
  var _a;
  if (!entityMap[key]) {
    console.error(`Invalid entity key '${key}' -- entry does not exist.`);
    return null;
  }
  const { type, data } = entityMap[key];
  const blockType = type === LINK_PREVIEW_TYPE && data.html ? EMBED_TYPE : type;
  const dataFieldName = TO_RICOS_DATA_FIELD[blockType];
  if (dataFieldName === void 0) {
    console.error(`Unknown entity type "${blockType}"!`);
    return null;
  }
  if (!data) {
    console.error(`no data for "${blockType}"!`);
    return null;
  }
  normalizeBlockData(type, data);
  const advancedPluginsAdditionalData = {
    [COLLAPSIBLE_LIST_TYPE]: { pairs: data == null ? void 0 : data.pairs },
    [TABLE_TYPE]: { rows: (_a = data == null ? void 0 : data.config) == null ? void 0 : _a.rows }
  };
  return __spreadValues$9({
    type: TO_RICOS_PLUGIN_TYPE[blockType],
    [dataFieldName]: convertBlockDataToRicos(blockType, data)
  }, advancedPluginsAdditionalData[blockType] || {});
};
const getTextStyle = (blockData) => {
  const { textAlignment, dynamicStyles } = blockData || {};
  const { "line-height": lineHeight } = dynamicStyles || {};
  const normalizedTextAlignment = textAlignment == null ? void 0 : textAlignment.toUpperCase();
  return {
    textAlignment: normalizedTextAlignment && supportedTextAlignments.includes(normalizedTextAlignment) ? normalizedTextAlignment : null,
    lineHeight
  };
};
const getNodeStyle = (blockData) => {
  const { dynamicStyles } = blockData || {};
  const {
    "padding-top": paddingTop,
    "padding-bottom": paddingBottom,
    backgroundColor
  } = dynamicStyles || {};
  const style = pickBy({ paddingTop, paddingBottom, backgroundColor }, identity$1);
  const hasStyle = Object.values(style).length > 0;
  return hasStyle ? style : void 0;
};

var __defProp$8 = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const HEX_COLOR_REGEXP = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
const isEmptyTextNode = (node) => {
  var _a;
  return node.type === Node_Type.TEXT && ((_a = node.textData) == null ? void 0 : _a.text) === "";
};
const removeUnsupportedEntities = (entityRanges, entityMap) => entityRanges.filter((range) => {
  var _a;
  return TO_RICOS_DECORATION_TYPE[(_a = entityMap[range.key]) == null ? void 0 : _a.type] !== void 0;
});
const removeUnsupportedDecorations = (inlineStyleRanges) => inlineStyleRanges.filter((range) => isDecorationType(range.style));
const mergeColorDecorations = (decorations) => {
  const colorDecorations = decorations.filter(
    (decoration) => decoration.type === Decoration_Type.COLOR
  );
  const otherDecorations = decorations.filter(
    (decoration) => decoration.type !== Decoration_Type.COLOR
  );
  return colorDecorations.length > 0 ? otherDecorations.concat([merge({}, ...colorDecorations)]) : otherDecorations;
};
const removeDuplicateDecorations = (decorations) => {
  const seenDecorations = /* @__PURE__ */ new Set();
  return [...decorations.reverse()].filter((decoration) => {
    if (seenDecorations.has(decoration.type)) {
      return false;
    }
    seenDecorations.add(decoration.type);
    return true;
  }).reverse();
};
const isDecorationType = (decorationType = "") => TO_RICOS_DECORATION_TYPE[decorationType] !== void 0 || TO_RICOS_INLINE_STYLE_TYPE[decorationType] !== void 0 || Object.keys(dynamicDecorationGetters).some(
  (dynamicType) => decorationType.includes(dynamicType) && isValidDecorationColor(decorationType)
) || HEX_COLOR_REGEXP.test(decorationType);
const getTextNodesWithLineBreaks = (textNodes) => textNodes.map(
  (node) => {
    var _a, _b;
    return extractLineBreaks((_b = (_a = node.textData) == null ? void 0 : _a.text) != null ? _b : "").map(
      (text) => {
        var _a2, _b2;
        return __spreadProps$7(__spreadValues$8({}, createTextNode(text)), {
          textData: {
            text,
            decorations: text === "\n" ? [] : (_b2 = (_a2 = node.textData) == null ? void 0 : _a2.decorations) != null ? _b2 : []
          }
        });
      }
    );
  }
).reduce((nodes, nodesArr) => [...nodes, ...nodesArr], []);
const extractLineBreaks = (text) => {
  if (!text.includes("\n") || text === "\n") {
    return [text];
  }
  const texts = text.split(/(\\*\n)/);
  const newLineRegex = /\\(\\)*\n$/;
  return texts.filter((text2) => text2.length !== 0).map((text2) => {
    return newLineRegex.test(text2) ? [text2.replace("\n", ""), "\n"] : [text2];
  }).reduce((acc, val) => [...acc, ...val], []).reduce((allTexts, current, index, array) => {
    if (index === 0) {
      return [current];
    }
    if (current === "\n") {
      return [...allTexts, current];
    }
    if (array[index - 1] === "\n") {
      return [...allTexts, current];
    }
    return [...allTexts.slice(0, -1), allTexts[allTexts.length - 1] + current];
  }, []);
};
const dynamicDecorationGetters = {
  FG: (style) => {
    return {
      type: Decoration_Type.COLOR,
      colorData: { foreground: style }
    };
  },
  BG: (style) => {
    return {
      type: Decoration_Type.COLOR,
      colorData: { background: style }
    };
  },
  "font-size": (style) => {
    const [value, unit] = style.split(/(px|em)/gi);
    return {
      type: Decoration_Type.FONT_SIZE,
      fontSizeData: {
        unit: unit.toUpperCase(),
        value: parseInt(value)
      }
    };
  }
};
const getTextNodes = (block, entityMap, { ignoreUnsupportedValues } = {}, withLineBreaks = true) => {
  const createTextNodeWithDecorations = ({
    text: text2,
    styles: styles2 = [],
    keys: keys2 = []
  }) => {
    const normalizedText = normalizeText(text2);
    const textNode = createTextNode(normalizedText);
    let decorations = [];
    const keysDecorations = removeDuplicateDecorations(
      keys2.map((key) => getEntity(key, entityMap)).filter((x) => x)
    );
    const stylesDecorations = flowRight(
      removeDuplicateDecorations,
      mergeColorDecorations
    )(styles2.map((style) => getDecoration(style)));
    decorations = [...decorations, ...keysDecorations, ...stylesDecorations].sort(
      decorationComparator$1
    );
    if (!isEmpty$1(decorations) && textNode.textData) {
      textNode.textData.decorations = decorations;
    }
    return textNode;
  };
  const getDecoration = (style) => {
    let decoration;
    try {
      const isLegacyFontColorDecoration = HEX_COLOR_REGEXP.test(style);
      const styleObj = isLegacyFontColorDecoration ? { FG: style } : JSON.parse(style);
      const type = Object.keys(styleObj)[0];
      const value = Object.values(styleObj)[0];
      decoration = dynamicDecorationGetters[type](value);
    } catch (e) {
      if (!isDecorationType(style) && !ignoreUnsupportedValues) {
        throw Error(`Unknown decoration type "${style}"!`);
      }
      decoration = TO_RICOS_INLINE_STYLE_TYPE[style] || {
        type: TO_RICOS_DECORATION_TYPE[style]
      };
    }
    return decoration;
  };
  const { text = "", inlineStyleRanges, entityRanges } = block;
  if (text.length === 0) {
    return [];
  }
  const dedupedStyleRanges = removeOverlappingRangesWithSameStyle(inlineStyleRanges);
  const supportedInlineStyleRanges = ignoreUnsupportedValues ? removeUnsupportedDecorations(dedupedStyleRanges) : dedupedStyleRanges;
  const mergedEntityRanges = mergeOverlappingEntityRanges(entityRanges);
  const rangeMap = generateRangeMap([
    ...supportedInlineStyleRanges,
    ...removeUnsupportedEntities(mergedEntityRanges, entityMap)
  ]);
  const textNodes = [];
  let styles = [];
  let keys = [];
  const numbers = Object.keys(rangeMap).map(Number);
  numbers.forEach((point, i) => {
    if (numbers[i] < text.length) {
      rangeMap[point].forEach((entry) => {
        if (entry.action === "start") {
          if ("style" in entry) {
            styles.push(entry.style);
          } else {
            keys.push(entry.key);
          }
        } else if ("style" in entry) {
          styles = styles.filter((s) => s !== entry.style);
        } else {
          keys = keys.filter((s) => s !== entry.key);
        }
      });
      textNodes.push(
        createTextNodeWithDecorations({
          text: Array.from(text).slice(numbers[i], numbers[i + 1]).join(""),
          styles,
          keys
        })
      );
    }
  });
  const nonEmptyTextNodes = textNodes.filter((node) => !isEmptyTextNode(node));
  return withLineBreaks ? getTextNodesWithLineBreaks(nonEmptyTextNodes) : nonEmptyTextNodes;
};
const decorationComparator$1 = (a, b) => a.type.localeCompare(b.type);
const isValidDecorationColor = (style) => {
  try {
    const styleObj = JSON.parse(style);
    const value = Object.values(styleObj)[0];
    if (value.startsWith("#")) {
      return HEX_COLOR_REGEXP.test(value);
    }
    return true;
  } catch (e) {
    return false;
  }
};
const normalizeText = (text) => {
  const headersRegex = /^\{\$h([1-5])\}(.*?)\{\$h\}/g;
  if (headersRegex.test(text)) {
    return text.replace(
      headersRegex,
      (matchedText) => matchedText.replace(/^\{\$h[1-5]\}|\{\$h\}$/g, "")
    );
  }
  return text;
};

const parseCollapsible = (entity, opts) => entity.pairs.map((pair) => ({
  id: pair.key,
  type: Node_Type.COLLAPSIBLE_ITEM,
  nodes: [
    {
      id: generateId(),
      type: Node_Type.COLLAPSIBLE_ITEM_TITLE,
      nodes: fromDraft(pair.title, opts).nodes
    },
    {
      id: generateId(),
      type: Node_Type.COLLAPSIBLE_ITEM_BODY,
      nodes: fromDraft(pair.content, opts).nodes
    }
  ]
}));
const parseTable = (entity, opts) => Object.entries(entity.rows).map(([, row]) => {
  var _a;
  return {
    id: generateId(),
    type: Node_Type.TABLE_ROW,
    nodes: Object.entries((_a = row.columns) != null ? _a : {}).map(([, cell]) => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      return {
        id: generateId(),
        type: Node_Type.TABLE_CELL,
        tableCellData: {
          cellStyle: {
            verticalAlignment: (_b = (_a2 = cell.style) == null ? void 0 : _a2.verticalAlign) == null ? void 0 : _b.toUpperCase(),
            backgroundColor: (_d = (_c = cell.style) == null ? void 0 : _c.backgroundColor) == null ? void 0 : _d.toUpperCase()
          },
          borderColors: {
            top: (_f = (_e = cell.border) == null ? void 0 : _e.top) == null ? void 0 : _f.toUpperCase(),
            left: (_h = (_g = cell.border) == null ? void 0 : _g.left) == null ? void 0 : _h.toUpperCase(),
            right: (_j = (_i = cell.border) == null ? void 0 : _i.right) == null ? void 0 : _j.toUpperCase(),
            bottom: (_l = (_k = cell.border) == null ? void 0 : _k.bottom) == null ? void 0 : _l.toUpperCase()
          }
        },
        nodes: fromDraft(cell.content, opts).nodes
      };
    })
  };
});
const nestedNodesConverters = {
  [Node_Type.COLLAPSIBLE_LIST]: parseCollapsible,
  [Node_Type.TABLE]: parseTable
};

const cssToRicosDecoration = {
  color: (style) => {
    return { type: Decoration_Type.COLOR, colorData: { foreground: style } };
  },
  "background-color": (style) => {
    return { type: Decoration_Type.COLOR, colorData: { background: style } };
  },
  "font-weight": (style) => {
    return { type: Decoration_Type.BOLD, fontWeightValue: style === "bold" ? 700 : 400 };
  },
  "font-style": (style) => {
    return { type: Decoration_Type.ITALIC, italicData: style === "italic" };
  },
  "text-decoration": (style) => {
    return { type: Decoration_Type.UNDERLINE, underlineData: style === "underline" };
  },
  "font-size": (style) => {
    const [value, unit] = style.split(/(px|em)/gi);
    return {
      type: Decoration_Type.FONT_SIZE,
      fontSizeData: { unit: unit.toUpperCase(), value: parseInt(value) }
    };
  }
};
const convertHeaderToRicosDecorations = (styles) => Object.entries(styles).filter(([key, _]) => cssToRicosDecoration[key]).map(([key, style]) => cssToRicosDecoration[key](style));
const convertCssToNodeStyle = (styles) => {
  return styles["padding-top"] || styles["padding-bottom"] ? {
    paddingTop: styles["padding-top"],
    paddingBottom: styles["padding-bottom"]
  } : void 0;
};
const normalizeColorDecorations = (decorations) => {
  var _a, _b, _c, _d;
  const background = (_b = (_a = decorations.find((decoration) => {
    var _a2;
    return (_a2 = decoration == null ? void 0 : decoration.colorData) == null ? void 0 : _a2.background;
  })) == null ? void 0 : _a.colorData) == null ? void 0 : _b.background;
  const foreground = (_d = (_c = decorations.find((decoration) => {
    var _a2;
    return (_a2 = decoration == null ? void 0 : decoration.colorData) == null ? void 0 : _a2.foreground;
  })) == null ? void 0 : _c.colorData) == null ? void 0 : _d.foreground;
  if (background && foreground) {
    const colorDecoration = { type: Decoration_Type.COLOR, colorData: { background, foreground } };
    return decorations.filter((decoration) => decoration.type !== Decoration_Type.COLOR).concat([colorDecoration]);
  }
  return decorations;
};
const parseDocStyle = (documentStyle) => {
  if (documentStyle) {
    const ricosDocumentStyle = {};
    Object.entries(documentStyle).forEach(([header, styles]) => {
      if (header) {
        const decorations = normalizeColorDecorations(
          convertHeaderToRicosDecorations(styles)
        );
        const nodeStyle = convertCssToNodeStyle(styles);
        const lineHeight = styles["line-height"];
        ricosDocumentStyle[header] = {};
        (decorations == null ? void 0 : decorations.length) > 0 && (ricosDocumentStyle[header].decorations = decorations);
        nodeStyle && (ricosDocumentStyle[header].nodeStyle = nodeStyle);
        lineHeight && (ricosDocumentStyle[header].lineHeight = lineHeight);
      }
    });
    return ricosDocumentStyle;
  }
};

var __defProp$7 = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
const ensureRicosContent = (content, opts) => "blocks" in content ? fromDraft(content, opts) : content;
const normalizeBlock = (block) => {
  var _a;
  if (block.type === "atomic" && block.text.startsWith(" ") && ((_a = block.text) == null ? void 0 : _a.length) > 1) {
    block.type = "unstyled";
  }
  block.depth = block.depth || 0;
  block.entityRanges = block.entityRanges || [];
  block.inlineStyleRanges = (block.inlineStyleRanges || []).filter((range) => range.offset >= 0).map((range) => {
    if (range.style.startsWith("#")) {
      return __spreadProps$6(__spreadValues$7({}, range), {
        style: `{"FG":"${range.style}"}`
      });
    }
    try {
      const parsedStyle = JSON.parse(range.style);
      if ("font-size" in parsedStyle) {
        const [value, unit] = parsedStyle["font-size"].split(/(px|em)/gi);
        return __spreadProps$6(__spreadValues$7({}, range), {
          style: `{"font-size":"${parseInt(value, 10)}${unit}"}`
        });
      }
    } catch (e) {
    }
    return range;
  });
};
const fromDraft = (draftJSON, opts = {}) => {
  const { blocks = [], entityMap = {}, documentStyle, ID: id } = cloneDeep(draftJSON);
  const nodes = [];
  const contentIdPrefix = Math.random().toString(36).substr(2, 9);
  const usedKeys = {};
  const withDepth = (block, depth = 0) => __spreadProps$6(__spreadValues$7({}, block), { depth });
  const ensureUniqueKey = (key) => {
    if (usedKeys[key]) {
      console.warn(`WARN! Duplicate block key "${key}"!`);
      key = generateId();
    }
    usedKeys[key] = true;
    return key;
  };
  const parseBlock = (index) => {
    let block = blocks[index];
    if (!block) {
      return -1;
    }
    block = removeInlineHeaderRanges(block);
    normalizeBlock(block);
    switch (block.type) {
      case BlockType.Atomic:
        const atomicBlocks = parseAtomicBlock(block);
        atomicBlocks == null ? void 0 : atomicBlocks.forEach((atomicBlock) => {
          nodes.push(atomicBlock);
        });
        return index + 1;
      case BlockType.Blockquote:
        nodes.push(parseQuoteBlock(block));
        return index + 1;
      case BlockType.CodeBlock:
        nodes.push(parseCodeBlock(block));
        return index + 1;
      case BlockType.HeaderOne:
      case BlockType.HeaderTwo:
      case BlockType.HeaderThree:
      case BlockType.HeaderFour:
      case BlockType.HeaderFive:
      case BlockType.HeaderSix:
        nodes.push(parseHeadingBlock(block));
        return index + 1;
      case BlockType.OrderedListItem:
      case BlockType.UnorderedListItem:
        const { node, nextIndex } = parseListBlocks(index);
        nodes.push(node);
        return nextIndex;
      case void 0:
      case BlockType.Unstyled:
        nodes.push(parseTextBlock(block));
        return index + 1;
      default:
        if (opts.ignoreUnsupportedValues) {
          return index + 1;
        } else {
          throw Error(`ERROR! Unknown block type "${block.type}"!`);
        }
    }
  };
  const parseAtomicBlock = (block) => {
    const { key, data, entityRanges } = block;
    if (entityRanges && entityRanges.length) {
      return entityRanges.map((entityRange) => {
        var _a, _b;
        const entity = getEntity(entityRange.key, entityMap);
        if (entity && entity.type) {
          switch (entity.type) {
            case Decoration_Type.LINK:
            case Decoration_Type.ANCHOR:
            case Decoration_Type.MENTION: {
              return parseTextBlock(block);
            }
            default: {
              const nodes2 = ((_b = (_a = nestedNodesConverters)[entity.type]) == null ? void 0 : _b.call(_a, entity, opts)) || [];
              const shouldAddStyle = ![
                Node_Type.IMAGE,
                Node_Type.VIDEO,
                Node_Type.DIVIDER,
                Node_Type.HTML,
                Node_Type.GALLERY,
                Node_Type.BUTTON,
                Node_Type.FILE,
                Node_Type.COLLAPSIBLE_LIST,
                Node_Type.GIF,
                Node_Type.TABLE,
                Node_Type.APP_EMBED,
                Node_Type.POLL
              ].includes(entity.type);
              return __spreadValues$7(__spreadValues$7({
                id: ensureUniqueKey(key),
                nodes: nodes2
              }, shouldAddStyle ? { style: getNodeStyle(data) } : {}), entity);
            }
          }
        }
        return null;
      }).filter((block2) => !!block2);
    }
    return null;
  };
  const parseQuoteBlock = (block) => ({
    id: ensureUniqueKey(block.key),
    type: Node_Type.BLOCKQUOTE,
    nodes: [parseTextBlock(withDepth(block))],
    style: getNodeStyle(block.data),
    blockquoteData: { indentation: block.depth }
  });
  const parseCodeBlock = (block) => ({
    id: ensureUniqueKey(block.key),
    type: Node_Type.CODE_BLOCK,
    nodes: getTextNodes(block, entityMap, opts, false),
    style: getNodeStyle(block.data),
    codeBlockData: {
      textStyle: getTextStyle(block.data)
    }
  });
  const parseHeadingBlock = (block) => {
    const getLevel = (blockType) => {
      if (Object.keys(HeaderLevel).includes(blockType)) {
        return HeaderLevel[blockType];
      }
      throw Error(`ERROR! Unknown header level "${blockType}"!`);
    };
    return {
      id: ensureUniqueKey(block.key),
      type: Node_Type.HEADING,
      headingData: {
        level: getLevel(block.type),
        indentation: block.depth,
        textStyle: getTextStyle(block.data)
      },
      nodes: getTextNodes(block, entityMap, opts),
      style: getNodeStyle(block.data)
    };
  };
  const parseTextBlock = (block) => {
    const paragraphNode = createParagraphNode(
      [],
      { textStyle: getTextStyle(block.data) },
      getNodeStyle(block.data)
    );
    switch (block.type) {
      case BlockType.Unstyled:
        paragraphNode.id = ensureUniqueKey(block.key);
      case void 0:
      case BlockType.Atomic:
      case BlockType.Blockquote:
        if (paragraphNode.paragraphData) {
          paragraphNode.paragraphData.indentation = parseDepth(block.depth);
        }
        break;
      case BlockType.OrderedListItem:
      case BlockType.UnorderedListItem:
        if (paragraphNode.paragraphData) {
          paragraphNode.paragraphData.indentation = parseDepth(block.depth);
        }
        paragraphNode.id = ensureUniqueKey(block.key);
        break;
    }
    const nodes2 = getTextNodes(block, entityMap, opts);
    if (!isEmpty$1(nodes2)) {
      paragraphNode.nodes = nodes2;
    }
    return paragraphNode;
  };
  const createListItem = (block) => ({
    id: generateId(contentIdPrefix),
    type: Node_Type.LIST_ITEM,
    nodes: [parseTextBlock(withDepth(block))]
  });
  const isListBlock = (block) => FROM_DRAFT_LIST_TYPE[block.type] !== void 0;
  const parseListBlocks = (listStartIndex) => {
    const { type: listType, depth } = blocks[listStartIndex];
    const listNodes = [];
    let searchIndex = listStartIndex;
    let nextBlock = blocks[searchIndex];
    while (nextBlock && isListBlock(nextBlock) && nextBlock.depth >= depth) {
      normalizeBlock(nextBlock);
      if (nextBlock.depth > depth) {
        const { node, nextIndex } = parseListBlocks(searchIndex);
        listNodes[listNodes.length - 1].nodes.push(node);
        searchIndex = nextIndex;
      } else if (nextBlock.type !== listType) {
        break;
      } else {
        listNodes.push(createListItem(nextBlock));
        searchIndex++;
      }
      nextBlock = blocks[searchIndex];
    }
    const listData = FROM_DRAFT_LIST_TYPE[listType] === Node_Type.ORDERED_LIST ? "orderedListData" : "bulletedListData";
    return {
      node: {
        id: generateId(contentIdPrefix),
        type: FROM_DRAFT_LIST_TYPE[listType],
        nodes: listNodes,
        [listData]: { indentation: depth }
      },
      nextIndex: searchIndex
    };
  };
  let i = 0;
  while (i !== -1) {
    i = parseBlock(i);
  }
  const content = {
    nodes,
    metadata: initializeMetadata({ id }),
    documentStyle: documentStyle && parseDocStyle(documentStyle)
  };
  return RichContent.fromJSON(content);
};
const parseDepth = (depth) => {
  if (isNaN(parseInt(depth.toString(), 10))) {
    return 0;
  }
  return parseInt(depth.toString(), 10);
};

var version = "9.18.4";

const toVersion = (versionString) => {
  return versionString.split(".").map((literal) => {
    const numeric = parseInt(literal, 10);
    return isNaN$1(numeric) ? 0 : numeric;
  }).slice(0, 3);
};
const compareVersions = (left, right) => {
  const leftVersion = toVersion(left);
  const rightVersion = toVersion(right);
  const diff = leftVersion.map((left2, idx) => Math.sign(left2 - rightVersion[idx]));
  return diff.find((num) => num !== 0) || 0;
};
const evaluations = {
  "<": (left, right) => compareVersions(left, right) < 0,
  ">": (left, right) => compareVersions(left, right) > 0,
  "=": (left, right) => compareVersions(left, right) === 0,
  "<=": (left, right) => compareVersions(left, right) <= 0,
  ">=": (left, right) => compareVersions(left, right) >= 0
};
const evaluateVersion = (tested, semver) => {
  const [, operator, version] = /([<>=]{0,2})(.*)/gm.exec(semver);
  return evaluations[operator || "="](tested, version);
};
var Version = {
  lessThan: (left, right) => compareVersions(left, right) < 0,
  greaterThan: (left, right) => compareVersions(left, right) > 0,
  equal: (left, right) => compareVersions(left, right) === 0,
  compare: compareVersions,
  currentVersion: version,
  evaluate: evaluateVersion
};

const emojiRegex = (
  // eslint-disable-next-line max-len
  /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])?|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#*0-9]\uFE0F\u20E3|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]/g
);

var space = toSpaceCase_1;

/**
 * Export.
 */

var toCamelCase_1 = toCamelCase;

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}

var __defProp$6 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
const convertContainerData = (data, nodeType) => {
  if (!data.containerData) {
    return;
  }
  const { width, alignment, spoiler, height, textWrap = true } = data.containerData;
  const { enabled = false, description, buttonText } = spoiler != null ? spoiler : {};
  const config = __spreadProps$5(__spreadValues$6({}, data.config), {
    size: getSize(nodeType, width == null ? void 0 : width.size, width == null ? void 0 : width.custom),
    width: getWidth(nodeType, width == null ? void 0 : width.custom),
    height: (height == null ? void 0 : height.custom) && parseInt(height.custom),
    alignment: alignment == null ? void 0 : alignment.toLowerCase(),
    spoiler: spoiler && {
      enabled,
      description,
      buttonContent: buttonText
    },
    textWrap: textWrap ? WRAP : NO_WRAP
  });
  return config;
};
const getSize = (nodeType, size, customWidth) => {
  const hasCustomWidth = customWidth !== void 0;
  if ((nodeType === Node_Type.IMAGE || nodeType === Node_Type.BUTTON) && hasCustomWidth) {
    return "inline";
  }
  if (nodeType === Node_Type.BUTTON) {
    return "small";
  }
  if (nodeType === Node_Type.MAP) {
    return "content";
  }
  if (size) {
    return toCamelCase_1(size);
  }
};
const getWidth = (nodeType, width) => {
  if (width) {
    if (nodeType === Node_Type.BUTTON && width === "fit-content") {
      return width;
    }
    return parseInt(width);
  }
  if (!width && nodeType === Node_Type.BUTTON) {
    return "fit-content";
  }
};

const updatePrivacyField = (target, isPrivate) => {
  const privacy = typeof isPrivate !== "undefined" ? isPrivate && "private" || "public" : void 0;
  target.privacy = privacy;
};

const isBoolValue = (val) => typeof val.boolValue === "boolean";
const isStringValue = (val) => typeof val.stringValue === "string";
const isNumberValue = (val) => typeof val.numberValue === "number";
const isArrayValue = (val) => {
  var _a;
  return isObject(val.listValue) && Array.isArray((_a = val.listValue) == null ? void 0 : _a.values);
};
const isStructValue = (val) => {
  var _a;
  return isObject(val.structValue) && isObject((_a = val.structValue) == null ? void 0 : _a.fields);
};
const isNullValue = (val) => val.nullValue === NullValue.NULL_VALUE;

const mergeJsonMap = getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const convertStructToJson = (message) => pipe$1(
  message.fields,
  Object.entries,
  map$1(bimap(convertValueToJson, identity)),
  map$1(toRecord),
  concatAll(mergeJsonMap)
);
const convertValueToJson = (message) => firstRight(message, null, [
  [isBoolValue, ({ boolValue }) => boolValue],
  [isNumberValue, ({ numberValue }) => numberValue],
  [isStringValue, ({ stringValue }) => stringValue],
  [isNullValue, () => null],
  [isArrayValue, (m) => convertListToJson(m.listValue || { values: [] })],
  [isStructValue, (m) => convertStructToJson(m.structValue || { fields: {} })]
]);
const convertListToJson = (message) => pipe$1(message.values, map$1(convertValueToJson));

var __defProp$5 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const parseLink = ({
  url,
  rel,
  target,
  anchor,
  customData
}) => ({
  anchor,
  url,
  rel: rel && Object.entries(rel).flatMap(([key, value]) => value ? key : []).join(" "),
  target: target && "_" + target.toLowerCase(),
  customData
});
const convertVideoData = (data) => {
  var _a, _b;
  const videoSrc = (_a = data.video) == null ? void 0 : _a.src;
  const { src, width, height } = data.thumbnail || {};
  if (videoSrc == null ? void 0 : videoSrc.url) {
    data.src = videoSrc.url;
    data.metadata = { thumbnail_url: src == null ? void 0 : src.url, width, height, title: data.title };
  } else if ((videoSrc == null ? void 0 : videoSrc.id) || (videoSrc == null ? void 0 : videoSrc.custom)) {
    const pathname = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
    data.src = {
      pathname: (videoSrc == null ? void 0 : videoSrc.id) || (videoSrc == null ? void 0 : videoSrc.custom),
      thumbnail: pathname ? { pathname, width, height } : void 0
    };
  }
  data.duration = (_b = data.video) == null ? void 0 : _b.duration;
  delete data.video;
  delete data.title;
  delete data.thumbnail;
};
const convertAudioData = (data) => {
  var _a, _b, _c, _d;
  const { coverImage } = data;
  if (coverImage) {
    const { width, height } = coverImage;
    const id = (_b = coverImage == null ? void 0 : coverImage.id) != null ? _b : (_a = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _a.id;
    const file_name = (_d = coverImage == null ? void 0 : coverImage.file_name) != null ? _d : (_c = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _c.id;
    data.coverImage = {
      id,
      file_name,
      width,
      height
    };
  }
};
const convertExternalData = (data) => {
  const draftData = convertStructToJson(data);
  Object.entries(draftData).forEach(([k, v]) => {
    data[k] = v;
  });
  delete data.fields;
};
const convertDividerData = (data) => {
  var _a, _b, _c;
  data.type = (_a = data.lineStyle) == null ? void 0 : _a.toLowerCase();
  delete data.lineStyle;
  data.config = data.config || {};
  if (has$1(data, "width")) {
    data.config.size = (_b = data.width) == null ? void 0 : _b.toLowerCase();
    delete data.width;
  }
  if (has$1(data, "alignment")) {
    data.config.alignment = (_c = data.alignment) == null ? void 0 : _c.toLowerCase();
    delete data.alignment;
  }
  delete data.containerData;
};
var GalleryLayout = /* @__PURE__ */ ((GalleryLayout2) => {
  GalleryLayout2[GalleryLayout2["COLLAGE"] = 0] = "COLLAGE";
  GalleryLayout2[GalleryLayout2["MASONRY"] = 1] = "MASONRY";
  GalleryLayout2[GalleryLayout2["GRID"] = 2] = "GRID";
  GalleryLayout2[GalleryLayout2["THUMBNAIL"] = 3] = "THUMBNAIL";
  GalleryLayout2[GalleryLayout2["SLIDER"] = 4] = "SLIDER";
  GalleryLayout2[GalleryLayout2["SLIDESHOW"] = 5] = "SLIDESHOW";
  GalleryLayout2[GalleryLayout2["PANORAMA"] = 6] = "PANORAMA";
  GalleryLayout2[GalleryLayout2["COLUMN"] = 7] = "COLUMN";
  GalleryLayout2[GalleryLayout2["MAGIC"] = 8] = "MAGIC";
  GalleryLayout2[GalleryLayout2["FULLSIZE"] = 9] = "FULLSIZE";
  return GalleryLayout2;
})(GalleryLayout || {});
const convertGalleryStyles = (options) => {
  const styles = {};
  has$1(options, "layout.type") && (styles.galleryLayout = parseInt(GalleryLayout[options.layout.type]));
  has$1(options, "layout.horizontalScroll") && (styles.oneRow = options.layout.horizontalScroll);
  has$1(options, "layout.orientation") && (styles.isVertical = options.layout.orientation === "COLUMNS");
  has$1(options, "layout.numberOfColumns") && (styles.numberOfImagesPerRow = options.layout.numberOfColumns);
  has$1(options, "layout.mobileNumberOfColumns") && (styles.m_numberOfImagesPerRow = options.layout.mobileNumberOfColumns);
  has$1(options, "item.targetSize") && (styles.gallerySizePx = options.item.targetSize);
  has$1(options, "item.ratio") && (styles.cubeRatio = options.item.ratio);
  has$1(options, "item.crop") && (styles.cubeType = options.item.crop.toLowerCase());
  has$1(options, "item.spacing") && (styles.imageMargin = options.item.spacing);
  has$1(options, "thumbnails.placement") && (styles.galleryThumbnailsAlignment = options.thumbnails.placement.toLowerCase());
  has$1(options, "thumbnails.spacing") && (styles.thumbnailSpacings = Math.trunc(options.thumbnails.spacing));
  return styles;
};
const convertGalleryItem = (item) => {
  var _a, _b;
  const type = has$1(item, "image") && !isEmpty$1(item.image) ? "image" : "video";
  const {
    src: { url },
    height,
    width
  } = ((_a = item[type]) == null ? void 0 : _a.media) || { src: {} };
  item.url = url;
  item.metadata = { height, width, type };
  has$1(item, "title") && (item.metadata.title = item.title);
  has$1(item, "altText") && (item.metadata.altText = item.altText);
  if (has$1(item, "video.thumbnail")) {
    const {
      src: { url: url2 },
      height: height2,
      width: width2
    } = item.video.thumbnail;
    item.metadata.poster = { url: url2, height: height2, width: width2 };
  }
  ((_b = item.image) == null ? void 0 : _b.link) && (item.metadata.link = parseLink(item.image.link));
  delete item.video;
  delete item.image;
  delete item.title;
  delete item.altText;
  return item;
};
const convertGalleryData = (data) => {
  has$1(data, "items") && (data.items = data.items.map((item) => convertGalleryItem(item)));
  has$1(data, "options") && (data.styles = convertGalleryStyles(data.options));
  delete data.options;
};
const convertImageData = (data) => {
  var _a, _b;
  const { link, config, image, altText, caption } = data;
  const { src, width, height } = image || {};
  const id = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
  data.src = id ? { id, file_name: id, width, height } : { url: src == null ? void 0 : src.url, source: "static", width, height };
  const links = __spreadValues$5(__spreadValues$5({}, (link == null ? void 0 : link.anchor) ? { anchor: link == null ? void 0 : link.anchor } : {}), link ? { link: parseLink(link) } : {});
  if ((_a = links.link) == null ? void 0 : _a.customData) {
    const parsedCustomData = parseLinkCustomData$1((_b = links.link) == null ? void 0 : _b.customData);
    merge(links.link, parsedCustomData);
    if (!parsedCustomData.customData) {
      delete links.link.customData;
    }
  }
  data.config = __spreadValues$5(__spreadValues$5({}, config || {}), links);
  data.metadata = typeof altText === "string" || typeof caption === "string" ? {
    caption,
    alt: altText
  } : void 0;
  delete data.image;
  delete data.link;
  delete data.caption;
  delete data.altText;
};
const convertGIFData = (data) => {
  const { original = {}, downsized = {}, height, width } = data;
  data.gif = {
    originalUrl: original.gif,
    originalMp4: original.mp4,
    stillUrl: original.still,
    downsizedUrl: downsized.gif,
    downsizedSmallMp4: downsized.mp4,
    downsizedStillUrl: downsized.still,
    height,
    width
  };
  delete data.original;
  delete data.downsized;
  delete data.height;
  delete data.width;
};
const convertPollData = (data) => {
  var _a;
  has$1(data, "layout.poll.type") && (data.layout.poll.type = data.layout.poll.type.toLowerCase());
  has$1(data, "layout.poll.direction") && (data.layout.poll.direction = data.layout.poll.direction.toLowerCase());
  if (has$1(data, "layout.options")) {
    data.layout.option = data.layout.options;
    delete data.layout.options;
  }
  if (has$1(data, "design")) {
    const { poll = {}, options = {} } = data.design;
    const { background, borderRadius } = poll;
    const getBackground = (background2) => {
      var _a2, _b, _c, _d, _e, _f, _g;
      return (background2 == null ? void 0 : background2.gradient) ? {
        angle: (_a2 = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _a2.angle,
        start: (_b = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _b.startColor,
        end: (_c = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _c.lastColor
      } : ((_e = (_d = background2 == null ? void 0 : background2.color) == null ? void 0 : _d.charAt) == null ? void 0 : _e.call(_d, 0)) === "#" ? background2 == null ? void 0 : background2.color : (_g = (_f = background2 == null ? void 0 : background2.image) == null ? void 0 : _f.src) == null ? void 0 : _g.url;
    };
    data.design = {
      poll: {
        backgroundType: (_a = background == null ? void 0 : background.type) == null ? void 0 : _a.toLowerCase(),
        background: getBackground(background),
        borderRadius: `${borderRadius}px`
      },
      option: { borderRadius: `${options.borderRadius}px` }
    };
  }
  has$1(data, "poll.pollId") && (data.poll.id = data.poll.pollId);
  delete data.poll.pollId;
  has$1(data, "poll.creatorId") && (data.poll.createdBy = data.poll.creatorId);
  delete data.poll.creatorId;
  has$1(data, "poll.image.src.url") && (data.poll.mediaId = data.poll.image.src.url);
  delete data.poll.image;
  has$1(data, "poll.options") && (data.poll.options = data.poll.options.map((_b) => {
    var _c = _b, { image } = _c, rest = __objRest$3(_c, ["image"]);
    var _a2;
    return __spreadValues$5({
      mediaId: (_a2 = image == null ? void 0 : image.src) == null ? void 0 : _a2.url
    }, rest);
  }));
  if (has$1(data, "poll.settings")) {
    const { showVotesCount, showVoters, permissions } = data.poll.settings;
    const { view, vote, allowMultipleVotes } = permissions || {};
    const getResultsVisibility = (view2) => view2 === "EVERYONE" ? "ALWAYS" : view2 === "VOTERS" ? "VOTERS_ONLY" : "ONLY_ME";
    data.poll.settings = {
      resultsVisibility: getResultsVisibility(view),
      multipleVotes: allowMultipleVotes,
      voteRole: vote,
      votersDisplay: showVoters,
      votesDisplay: showVotesCount
    };
  }
  data.config.size = "large";
  data.config.width = "full-width";
};
const convertAppEmbedData = (data) => {
  const { type, itemId, name, image, url, bookingData, eventData, imageSrc } = data;
  const { src, width, height } = image || {};
  data.type = type.toLowerCase();
  const selectedProduct = __spreadValues$5(__spreadValues$5({
    id: itemId,
    name,
    imageSrc: (src == null ? void 0 : src.url) || imageSrc,
    pageUrl: url
  }, bookingData || {}), eventData || {});
  width && (selectedProduct.imageWidth = width);
  height && (selectedProduct.imageHeight = height);
  data.selectedProduct = selectedProduct;
  delete data.id;
  delete data.itemId;
  delete data.name;
  delete data.imageSrc;
  delete data.image;
  delete data.url;
  bookingData && delete data.bookingData;
  eventData && delete data.eventData;
};
const convertLinkPreviewData = (data) => {
  if (data.thumbnailUrl) {
    data.thumbnail_url = data.thumbnailUrl;
    delete data.thumbnailUrl;
  }
  if (data.link) {
    data.config.link = parseLink(data.link);
    delete data.link;
  }
};
const convertFileData = (data) => {
  const { url, id, custom, private: isPrivate } = data.src || {};
  data.url = url;
  data.id = id || custom;
  updatePrivacyField(data, isPrivate);
  delete data.src;
};
const convertButtonData = (data) => {
  const { link, text, type, styles } = data;
  const { colors, border } = styles || {};
  const { width, radius } = border || {};
  const convertedLink = type === ButtonData_Type.LINK && link ? parseLink(link) : {};
  data.button = {
    settings: __spreadValues$5({
      buttonText: text
    }, convertedLink),
    design: {
      borderRadius: radius,
      borderWidth: width,
      background: colors == null ? void 0 : colors.background,
      color: colors == null ? void 0 : colors.text,
      borderColor: colors == null ? void 0 : colors.border
    }
  };
  delete data.link;
  delete data.text;
  delete data.type;
  delete data.styles;
};
const convertHTMLData = (data) => {
  var _a;
  const { html, url, source } = data;
  const srcType = typeof html === "string" ? "html" : "url";
  data.srcType = srcType;
  data.src = (_a = html || url) != null ? _a : "";
  source === HTMLData_Source.ADSENSE && (data.config.isAdsense = true);
  delete data.source;
  delete data[srcType];
};
const convertMapData = (data) => {
  const {
    draggable,
    marker,
    streetViewControl,
    zoomControl,
    locationName,
    viewModeControl,
    initialZoom,
    mapType
  } = data.mapSettings;
  data.mapSettings.isDraggingAllowed = draggable;
  data.mapSettings.isMarkerShown = marker;
  data.mapSettings.isStreetViewControlShown = streetViewControl;
  data.mapSettings.isZoomControlShown = zoomControl;
  data.mapSettings.locationDisplayName = locationName;
  data.mapSettings.zoom = initialZoom;
  data.mapSettings.mode = mapType == null ? void 0 : mapType.toLowerCase();
  delete data.mapSettings.draggable;
  delete data.mapSettings.marker;
  delete data.mapSettings.streetViewControl;
  delete data.mapSettings.zoomControl;
  delete data.mapSettings.locationName;
  delete data.mapSettings.initialZoom;
  delete data.mapSettings.mapType;
  if (viewModeControl) {
    data.mapSettings.isViewControlShown = viewModeControl;
    delete data.mapSettings.viewModeControl;
  }
};
const convertEmbedData = (data) => {
  data.config = __spreadProps$4(__spreadValues$5({}, (data == null ? void 0 : data.config) || {}), {
    alignment: "center",
    size: "content",
    link: { url: data.src, target: "_blank", rel: "noopener" }
  });
  const { html, thumbnailUrl, title, description } = data.oembed;
  data.html = html;
  thumbnailUrl && (data.thumbnail_url = thumbnailUrl);
  typeof title === "string" && (data.title = title);
  description && (data.description = description);
  delete data.oembed;
  delete data.src;
};
const parseLinkCustomData$1 = (customData) => {
  try {
    return { customData: JSON.parse(customData) };
  } catch (e) {
    console.error("failed to parse customData", customData);
    return { customData };
  }
};
const converters = {
  [Node_Type.VIDEO]: convertVideoData,
  [Node_Type.AUDIO]: convertAudioData,
  [Node_Type.DIVIDER]: convertDividerData,
  [Node_Type.FILE]: convertFileData,
  [Node_Type.GIF]: convertGIFData,
  [Node_Type.IMAGE]: convertImageData,
  [Node_Type.POLL]: convertPollData,
  [Node_Type.APP_EMBED]: convertAppEmbedData,
  [Node_Type.LINK_PREVIEW]: convertLinkPreviewData,
  [Node_Type.BUTTON]: convertButtonData,
  [Node_Type.HTML]: convertHTMLData,
  [Node_Type.MAP]: convertMapData,
  [Node_Type.EMBED]: convertEmbedData,
  [Node_Type.GALLERY]: convertGalleryData,
  [Node_Type.EXTERNAL]: convertExternalData
};

var __defProp$4 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const convertNodeToDraftData = (node) => {
  const { type } = node;
  const draftPluginType = FROM_RICOS_ENTITY_TYPE[type];
  const dataFieldName = TO_RICOS_DATA_FIELD[draftPluginType];
  if (!dataFieldName) {
    console.error(`No data field name | Plugin Name: ${draftPluginType}`);
  }
  return convertNodeDataToDraft(type, node[dataFieldName] || {}, node.nodes);
};
const convertDecorationToDraftData = (decoration) => {
  const { type } = decoration;
  const dataFieldName = TO_RICOS_DECORATION_DATA_FIELD[FROM_RICOS_DECORATION_TYPE[type]];
  return convertDecorationDataToDraft(type, decoration[dataFieldName]);
};
const convertNodeDataToDraft = (nodeType, data, nodes) => {
  if (!data) {
    if (![
      Node_Type.COLLAPSIBLE_ITEM,
      Node_Type.COLLAPSIBLE_ITEM_BODY,
      Node_Type.COLLAPSIBLE_ITEM_TITLE
    ].includes(nodeType)) {
      console.error(`No data for ${nodeType}`);
    }
    return {};
  }
  const converters$1 = __spreadProps$3(__spreadValues$4({}, converters), {
    [Node_Type.COLLAPSIBLE_LIST]: convertCollapsibleListData,
    [Node_Type.TABLE]: convertTableData
  });
  const newData = __spreadProps$3(__spreadValues$4({}, cloneDeep(data)), {
    config: convertContainerData(data, nodeType),
    containerData: void 0
  });
  if (nodeType in converters$1) {
    const convert = converters$1[nodeType];
    convert(newData, nodes);
  }
  return JSON.parse(JSON.stringify(newData));
};
const convertDecorationDataToDraft = (decorationType, data) => {
  const converters = {
    [Decoration_Type.MENTION]: convertMentionData,
    [Decoration_Type.LINK]: convertLinkData
  };
  if (decorationType in converters) {
    const convert = converters[decorationType];
    const newData = cloneDeep(data);
    convert(newData);
    return newData;
  }
  return data;
};
const convertMentionData = (data) => {
  data.mention = { slug: data.slug, name: data.name, id: data.id };
  delete data.name;
  delete data.slug;
  delete data.id;
};
const convertCollapsibleListData = (data, nodes) => {
  const { initialExpandedItems, expandOnlyOne, direction, isQapageData } = data || {};
  const getExpandState = (initialExpandedItems2) => {
    if (initialExpandedItems2 === "ALL") {
      return "expanded";
    }
    if (initialExpandedItems2 === "NONE") {
      return "collapsed";
    }
    return "first_expanded";
  };
  const config = {
    expandState: getExpandState(initialExpandedItems),
    expandOnlyOne,
    isQapageData,
    direction: direction == null ? void 0 : direction.toLowerCase()
  };
  data.config = __spreadValues$4(__spreadValues$4({}, data.config), config);
  data.pairs = nodes.map((node) => {
    const _a = toDraft(node.nodes[0]), title = __objRest$2(_a, ["VERSION", "ID"]);
    const _b = toDraft(node.nodes[1]), content = __objRest$2(_b, ["VERSION", "ID"]);
    return {
      key: node.id,
      title,
      content
    };
  });
  delete data.initialExpandedItems;
  delete data.expandOnlyOne;
  delete data.isQapageData;
  delete data.direction;
  delete data.config.alignment;
};
const convertLinkData = (data) => {
  if (data.link) {
    const { url, target, anchor, rel, customData } = parseLink$1(data.link);
    data.url = url;
    if (target) {
      data.target = target;
    }
    if (rel) {
      data.rel = rel;
    }
    if (anchor) {
      data.anchor = anchor;
    }
    if (customData) {
      const customDataObj = parseLinkCustomData(customData);
      merge(data, customDataObj);
    }
    delete data.link;
  }
};
const parseLinkCustomData = (customData) => {
  try {
    return { customData: JSON.parse(customData) };
  } catch (e) {
    console.error("failed to parse customData", customData);
    return { customData };
  }
};
const convertTableData = (data, nodes) => {
  const {
    dimensions: { colsWidthRatio, rowsHeight, colsMinWidth },
    header,
    rowHeader,
    columnHeader
  } = data || {};
  const _a = data.config || {}, rest = __objRest$2(_a, ["alignment"]);
  data.config = __spreadProps$3(__spreadValues$4({}, rest), {
    colsWidth: colsWidthRatio,
    rowsHeight,
    colsMinWidth,
    rowHeader: rowHeader != null ? rowHeader : header,
    colHeader: columnHeader
  });
  const rows = {};
  nodes.forEach((row, i) => {
    rows[i] = { columns: {} };
    row.nodes.forEach((cell, j) => {
      var _b, _c, _d, _e, _f, _g;
      const _a2 = toDraft(cell), content = __objRest$2(_a2, ["VERSION", "ID"]);
      const { cellStyle = {}, borderColors = {} } = cell.tableCellData || {};
      rows[i].columns[j] = {
        content,
        style: {
          verticalAlign: (_b = cellStyle.verticalAlignment) == null ? void 0 : _b.toLowerCase(),
          backgroundColor: (_c = cellStyle.backgroundColor) == null ? void 0 : _c.toLowerCase()
        },
        border: {
          top: (_d = borderColors.top) == null ? void 0 : _d.toLowerCase(),
          left: (_e = borderColors.left) == null ? void 0 : _e.toLowerCase(),
          right: (_f = borderColors.right) == null ? void 0 : _f.toLowerCase(),
          bottom: (_g = borderColors.bottom) == null ? void 0 : _g.toLowerCase()
        }
      };
    });
  });
  data.config.rows = rows;
  delete data.dimensions;
  delete data.header;
  delete data.rowHeader;
  delete data.columnHeader;
};

var __defProp$3 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const getNodeEntityData = (node) => {
  var _a;
  const { type } = node;
  let draftPluginType = FROM_RICOS_ENTITY_TYPE[type];
  if (type === Node_Type.BUTTON) {
    draftPluginType = ((_a = node.buttonData) == null ? void 0 : _a.type) === ButtonData_Type.ACTION ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE;
  } else if (type === Node_Type.EMBED) {
    draftPluginType = LINK_PREVIEW_TYPE;
  }
  const data = convertNodeToDraftData(node);
  if (data === void 0) {
    throw Error(`ERROR! Unknown entity type "${type}"!`);
  }
  return { type: draftPluginType, data };
};
const createDecorationEntityData = (decoration, entityKey) => {
  const { type, emojiData } = decoration;
  const data = emojiData || convertDecorationToDraftData(__spreadProps$2(__spreadValues$3({}, decoration), {
    type: TO_RICOS_DECORATION_TYPE[type]
  }));
  if (data === void 0) {
    throw Error(`ERROR! Unknown entity type "${type}"!`);
  }
  const mutability = ENTITY_DECORATION_TO_MUTABILITY[type];
  return createEntity(entityKey, { type, mutability, data });
};
const createAtomicEntityData = (node, entityKey) => {
  const { type, data } = getNodeEntityData(node);
  return createEntity(entityKey, { type, mutability: "IMMUTABLE", data });
};
const getDynamicStyles = (node) => {
  const { textStyle } = node[RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]] || {};
  const { textAlignment, lineHeight } = textStyle || {};
  const { paddingTop, paddingBottom } = node.style || {};
  return {
    textAlignment,
    lineHeight,
    paddingTop,
    paddingBottom
  };
};
const createTextBlockData = (node) => {
  const { indentation = 0 } = node[RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]] || {};
  const { textAlignment, lineHeight, paddingTop, paddingBottom } = getDynamicStyles(node);
  return JSON.parse(
    JSON.stringify({
      textAlignment: textAlignment !== "AUTO" ? textAlignment == null ? void 0 : textAlignment.toLowerCase() : void 0,
      dynamicStyles: (paddingTop || paddingBottom || lineHeight) && {
        "padding-top": paddingTop,
        "padding-bottom": paddingBottom,
        "line-height": lineHeight
      },
      depth: indentation
    })
  );
};
const createEntity = (key, { type, mutability, data }) => {
  return { [key.toString()]: { type, mutability, data } };
};

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isInlineStyleDecoration = (decorationType) => TO_RICOS_DECORATION_DATA_FIELD[decorationType] === void 0;
const pipe = (arg, ...fns) => {
  return fns.reduce((v, fn) => fn(v), arg);
};
const mergeTextNodes = (nodes) => {
  let length = 0;
  return nodes.reduce(
    ({ text, decorationMap }, currNode) => {
      let accText = text;
      if (currNode.textData) {
        const { text: currText, decorations: currDecorations } = currNode.textData;
        const textLength = Array.from(currText).length;
        accText += currText;
        if (currDecorations) {
          convertDecorationTypes(currDecorations).forEach((decoration) => {
            if (!decorationMap[decoration.type]) {
              decorationMap[decoration.type] = [];
            }
            decorationMap[decoration.type] = [
              ...decorationMap[decoration.type],
              __spreadProps$1(__spreadValues$2({}, decoration), {
                start: length,
                end: length + textLength
              })
            ];
          });
        }
        length += textLength;
      }
      return { text: accText, decorationMap };
    },
    { text: "", decorationMap: {} }
  );
};
const mergeParagraphNodes = (nodes) => {
  return nodes.reduce(
    ({ text, decorationMap }, currNode) => {
      if (currNode.type !== Node_Type.PARAGRAPH) {
        return { text, decorationMap };
      }
      const mergedText = mergeTextNodes(currNode.nodes);
      const resultText = text && text !== "" ? `${text}
${mergedText.text}` : `${text}${mergedText.text}`;
      return { text: resultText, decorationMap: __spreadValues$2(__spreadValues$2({}, decorationMap), mergedText.decorationMap) };
    },
    { text: "", decorationMap: {} }
  );
};
const parseDecorations = (decorationMap, text) => {
  const nonMergableDecorations = [LINK_TYPE, MENTION_TYPE, ANCHOR_TYPE];
  const decorations = Object.values(decorationMap).sort(decorationComparator).reduce((decorations2, currentDecorations) => {
    if (currentDecorations.length > 0) {
      const firstDecoration = currentDecorations.shift();
      const mergedDecorations = [firstDecoration];
      currentDecorations.forEach((decoration) => {
        const lastDecoration = mergedDecorations.pop();
        if (decoration.start === lastDecoration.end && !nonMergableDecorations.includes(decoration.type)) {
          mergedDecorations.push(__spreadProps$1(__spreadValues$2({}, lastDecoration), { end: decoration.end }));
        } else {
          mergedDecorations.push(lastDecoration, decoration);
        }
      });
      return [...decorations2, ...mergedDecorations.sort(decorationComparator)];
    }
    return decorations2;
  }, []);
  const allDecorations = [...decorations, ...createEmojiDecorations(text)];
  const entityDecorations = allDecorations.filter(({ type }) => !isInlineStyleDecoration(type)).sort(decorationComparator);
  const inlineStyleDecorations = allDecorations.filter(({ type }) => isInlineStyleDecoration(type));
  return { inlineStyleDecorations, entityDecorations };
};
const parseInlineStyleDecorations = (decorations) => {
  const inlineStyleRanges = decorations.reduce(
    (inlineStyleRanges2, decoration) => [
      ...inlineStyleRanges2,
      {
        style: decoration.type,
        offset: decoration.start,
        length: decoration.end - decoration.start
      }
    ],
    []
  );
  return inlineStyleRanges;
};
const parseEntityDecorations = (decorations, latestEntityKey) => {
  const {
    entityRanges,
    entityMap,
    latestEntityKey: newLatestEntityKey
  } = decorations.reduce(
    ({ entityRanges: entityRanges2, entityMap: entityMap2, latestEntityKey: latestEntityKey2 }, decoration) => {
      const newEntityKey = latestEntityKey2 + 1;
      const newEntityMap = createDecorationEntityData(decoration, newEntityKey);
      return {
        entityRanges: [
          ...entityRanges2,
          {
            key: newEntityKey,
            offset: decoration.start,
            length: decoration.end - decoration.start
          }
        ],
        entityMap: __spreadValues$2(__spreadValues$2({}, entityMap2), newEntityMap),
        latestEntityKey: newEntityKey
      };
    },
    { entityRanges: [], entityMap: {}, latestEntityKey }
  );
  return {
    entityRanges,
    entityMap,
    latestEntityKey: newLatestEntityKey
  };
};
const getParagraphNode = (node) => {
  if (node.nodes[0].type === Node_Type.PARAGRAPH) {
    return node.nodes[0];
  } else {
    throw Error(`Expected a paragraph node but found ${node.nodes[0].type}`);
  }
};
const convertDecorationTypes = (decorations) => decorations.flatMap(
  (decoration) => pipe(
    decoration,
    toDraftDecorationType,
    convertFontSize,
    convertFontWeight,
    convertItalic,
    convertUnderline,
    splitColorDecoration
  )
);
const createEmojiDecorations = (text) => {
  const result = [];
  let match;
  while ((match = emojiRegex.exec(text)) !== null) {
    const { 0: emojiUnicode, index: start } = match;
    const decoration = {
      type: "EMOJI_TYPE",
      emojiData: { emojiUnicode },
      start,
      end: start + Array.from(emojiUnicode).length
    };
    result.push(decoration);
  }
  return result;
};
const toDraftDecorationType = (decoration) => {
  const type = omit(FROM_RICOS_DECORATION_TYPE, [
    Decoration_Type.BOLD,
    Decoration_Type.ITALIC,
    Decoration_Type.UNDERLINE
  ])[decoration == null ? void 0 : decoration.type];
  return type ? __spreadProps$1(__spreadValues$2({}, decoration), { type }) : decoration;
};
const splitColorDecoration = (_a) => {
  var _b = _a, {
    colorData
  } = _b, decoration = __objRest$1(_b, [
    "colorData"
  ]);
  if (!colorData) {
    return decoration;
  }
  const { foreground, background } = colorData;
  return [foreground && { FG: foreground }, background && { BG: background }].filter((x) => x).map((type) => __spreadProps$1(__spreadValues$2({}, decoration), { type: JSON.stringify(type) }));
};
const convertFontSize = (_c) => {
  var _d = _c, {
    fontSizeData
  } = _d, decoration = __objRest$1(_d, [
    "fontSizeData"
  ]);
  var _a, _b;
  return fontSizeData ? __spreadProps$1(__spreadValues$2({}, decoration), {
    type: JSON.stringify({
      "font-size": ((_a = fontSizeData.value) == null ? void 0 : _a.toString()) + (((_b = fontSizeData.unit) == null ? void 0 : _b.toLowerCase()) || "px")
    })
  }) : decoration;
};
const convertFontWeight = (_e) => {
  var _f = _e, {
    fontWeightValue
  } = _f, decoration = __objRest$1(_f, [
    "fontWeightValue"
  ]);
  return decoration.type === Decoration_Type.BOLD ? __spreadProps$1(__spreadValues$2({}, decoration), {
    type: !fontWeightValue || fontWeightValue >= 700 ? "BOLD" : "NOT_BOLD"
  }) : decoration;
};
const convertItalic = (_g) => {
  var _h = _g, {
    italicData
  } = _h, decoration = __objRest$1(_h, [
    "italicData"
  ]);
  const isItalicDataUndefined = typeof italicData === "undefined";
  return decoration.type === Decoration_Type.ITALIC ? __spreadProps$1(__spreadValues$2({}, decoration), {
    type: isItalicDataUndefined || italicData ? "ITALIC" : "NOT_ITALIC"
  }) : decoration;
};
const convertUnderline = (_i) => {
  var _j = _i, {
    underlineData
  } = _j, decoration = __objRest$1(_j, [
    "underlineData"
  ]);
  const isUnerlineDataUndefined = typeof underlineData === "undefined";
  return decoration.type === Decoration_Type.UNDERLINE ? __spreadProps$1(__spreadValues$2({}, decoration), {
    type: isUnerlineDataUndefined || underlineData ? "UNDERLINE" : "NOT_UNDERLINE"
  }) : decoration;
};
const decorationComparator = (a, b) => "start" in a && "start" in b ? a.start - b.start : a[0].start - b[0].start;

/**
 * @since 2.10.0
 */
/**
 * Converts a JavaScript Object Notation (JSON) string into a `Json` type.
 *
 * @example
 * import * as J from 'fp-ts/Json'
 * import * as E from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(pipe('{"a":1}', J.parse), E.right({ a: 1 }))
 * assert.deepStrictEqual(pipe('{"a":}', J.parse), E.left(new SyntaxError('Unexpected token } in JSON at position 5')))
 *
 * @since 2.10.0
 */
var parse = function (s) { return tryCatch(function () { return JSON.parse(s); }, identity); };

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const keyToId = (v) => (v == null ? void 0 : v.key) !== void 0 ? __spreadValues$1({ id: v.key }, v) : v;
const bulletToBulleted = (v) => v === "BULLET_LIST" ? Node_Type.BULLETED_LIST : v;
const appEmbedIdToItemId = (v) => (v == null ? void 0 : v.id) && (v == null ? void 0 : v.imageSrc) ? __spreadProps(__spreadValues$1({}, v), { itemId: v.id }) : v;
const replacer = (_, v) => pipe$1(v, keyToId, bulletToBulleted, appEmbedIdToItemId);
var preprocess = flow(
  stringifyWithReplace(replacer),
  chain(parse),
  fold(
    () => ({}),
    (res) => res
  )
);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const convert = (options = { ignoreUnsupportedTypes: false }) => (ricosContent) => {
  var _a;
  const { nodes, documentStyle } = ricosContent;
  const draftContent = {
    blocks: [],
    entityMap: {}
  };
  let latestEntityKey = -1;
  const usedKeys = {};
  const parseNodes = () => {
    nodes.forEach((node, index) => {
      var _a2;
      const prevNode = nodes[index - 1];
      if (node) {
        switch (node.type) {
          case Node_Type.BLOCKQUOTE:
            parseTextNodes(getParagraphNode(node), {
              type: BlockType.Blockquote,
              key: node.id,
              indentation: (_a2 = node.blockquoteData) == null ? void 0 : _a2.indentation
            });
            break;
          case Node_Type.CODE_BLOCK:
            parseTextNodes(node, { type: BlockType.CodeBlock, key: node.id });
            break;
          case Node_Type.HEADING:
            if (!node.headingData) {
              throw Error(`ERROR! Heading node with no data!`);
            }
            parseTextNodes(node, { type: HeaderLevel[node.headingData.level], key: node.id });
            break;
          case Node_Type.ORDERED_LIST:
          case Node_Type.BULLETED_LIST:
            if ((prevNode == null ? void 0 : prevNode.type) === node.type) {
              addBlock({ type: BlockType.Atomic });
            }
            parseListNode(node);
            break;
          case Node_Type.PARAGRAPH:
            parseTextNodes(node, { type: BlockType.Unstyled, key: node.id });
            break;
          default:
            if (RICOS_NODE_TYPE_TO_DATA_FIELD[node.type]) {
              parseAtomicNode(node);
            } else if (!options.ignoreUnsupportedTypes) {
              throw Error(`ERROR! Unknown node type "${node.type}"!`);
            }
        }
      }
    });
  };
  const parseAtomicNode = (node) => {
    latestEntityKey += 1;
    const entityMap = createAtomicEntityData(node, latestEntityKey);
    addBlock({
      key: node.id,
      type: BlockType.Atomic,
      text: " ",
      entityRanges: [{ offset: 0, length: 1, key: latestEntityKey }]
    });
    draftContent.entityMap = __spreadValues(__spreadValues({}, draftContent.entityMap), entityMap);
  };
  const parseListNode = (node, indent) => {
    var _a2, _b, _c, _d, _e;
    const indentation = (_e = (_d = (_c = (_a2 = node.bulletedListData) == null ? void 0 : _a2.indentation) != null ? _c : (_b = node.orderedListData) == null ? void 0 : _b.indentation) != null ? _d : indent) != null ? _e : 0;
    node.nodes.forEach((listItem) => {
      parseParagraphNodes(listItem, {
        type: TO_DRAFT_LIST_TYPE[node.type],
        key: listItem.nodes[0].id,
        indentation
      });
      const nestedListItem = listItem.nodes.find(
        (node2) => node2.type === Node_Type.ORDERED_LIST || node2.type === Node_Type.BULLETED_LIST
      );
      if (nestedListItem) {
        parseListNode(nestedListItem, indentation + 1);
      }
    });
  };
  const parseParagraphNodes = (node, { type, key, indentation }) => {
    const { text, decorationMap } = mergeParagraphNodes(node.nodes);
    const { inlineStyleDecorations, entityDecorations } = parseDecorations(decorationMap, text);
    const inlineStyleRanges = parseInlineStyleDecorations(inlineStyleDecorations);
    const {
      entityRanges,
      entityMap,
      latestEntityKey: newLatestEntityKey
    } = parseEntityDecorations(entityDecorations, latestEntityKey);
    latestEntityKey = newLatestEntityKey;
    const _a2 = createTextBlockData(node.nodes[0]), { depth } = _a2, data = __objRest(_a2, ["depth"]);
    addBlock({
      key,
      type,
      text,
      depth: indentation || depth,
      inlineStyleRanges,
      entityRanges,
      data
    });
    draftContent.entityMap = __spreadValues(__spreadValues({}, draftContent.entityMap), entityMap);
  };
  const parseTextNodes = (node, { type, key, indentation }) => {
    const { text, decorationMap } = mergeTextNodes(node.nodes);
    const { inlineStyleDecorations, entityDecorations } = parseDecorations(decorationMap, text);
    const inlineStyleRanges = parseInlineStyleDecorations(inlineStyleDecorations);
    const {
      entityRanges,
      entityMap,
      latestEntityKey: newLatestEntityKey
    } = parseEntityDecorations(entityDecorations, latestEntityKey);
    latestEntityKey = newLatestEntityKey;
    const _a2 = createTextBlockData(node), { depth } = _a2, data = __objRest(_a2, ["depth"]);
    addBlock({
      key,
      type,
      text,
      depth: indentation || depth,
      inlineStyleRanges,
      entityRanges,
      data
    });
    draftContent.entityMap = __spreadValues(__spreadValues({}, draftContent.entityMap), entityMap);
  };
  const addBlock = (blockProps) => {
    const newBlock = merge(
      {
        key: generateId(),
        type: BlockType.Unstyled,
        text: "",
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {}
      },
      blockProps
    );
    if (usedKeys[newBlock.key] && newBlock.key !== "") {
      console.warn(`WARN! Duplicate block key "${newBlock.key}"!`);
      newBlock.key = generateId();
    }
    usedKeys[newBlock.key] = true;
    draftContent.blocks = [...draftContent.blocks, newBlock];
  };
  parseNodes();
  documentStyle && (draftContent.documentStyle = parseDocStyle$1(documentStyle));
  draftContent.VERSION = Version.currentVersion;
  draftContent.ID = ((_a = ricosContent.metadata) == null ? void 0 : _a.id) || v4();
  return draftContent;
};
const toDraft = (content, options = { ignoreUnsupportedTypes: false }) => pipe$1(content, preprocess, convert(options));
const ensureDraftContent = (content) => "nodes" in content ? toDraft(content) : content;

export { convertBlockDataToRicos, convertDecorationDataToDraft, convertDecorationToDraftData, convertNodeDataToDraft, convertNodeToDraftData, ensureDraftContent, ensureRicosContent, fromDraft, toDraft };
